import React, { useState, useRef, useContext, useEffect } from "react";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Webcam from "react-webcam"; // Import react-webcam
import { User } from "react-feather"; // Import the User icon
import axios from "axios";
import {
  fetchVisitorTypes,
  fetchNationality,
  fetchIdProofTypes,
  fetchMeetingVenues,
  fetchBuildingsByGate,
} from "../../services/Api";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import { useReactToPrint } from "react-to-print";
import centerImage from "../../assets/infosys.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import QRCode from "qrcode";
import { SelfieSegmentation } from "@mediapipe/selfie_segmentation";
import { FaceDetection } from "@mediapipe/face_detection";
import SignatureCanvas from 'react-signature-canvas';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 28px;
  @media (max-width: 768px) {
    padding: 10px;
  }
`;
const FormRow = styled.div`
  display: flex;
  gap: 20px; /* Adjust spacing between inputs */
  justify-content: space-between;
  width: 100%;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Heading = styled.h1`
  font-size: 25px;
  font-family: "Segoe UI", Semibold;
  color: #2b3497;
  margin: 0;
  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

const Button = styled.button`
  width: 81px;
  height: 32px;
  border-radius: 7px;
  box-shadow: 0px 5px 10px #2b349754;
  color: white;
  font-size: 14px;
  border: none;
  cursor: pointer;
  font-family: "Segoe UI", Semibold;
`;

const ResetButton = styled(Button)`
  background-color: red;
`;

const SubmitButton = styled(Button)`
  background-color: #2b3497;
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 10px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Card = styled.div`
  flex: 1;
  background: #fff;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 27px;
  opacity: 1;
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  font-family: "Segoe UI", Semibold;
  color: #000000;
  margin-bottom: 5px;
  font-weight: 600;
`;

const Asterisk = styled.span`
  color: red;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: "Segoe UI", Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }
`;
const InputLabelN = styled.label`
  margin-bottom: 5px;
  display: block;
  font-weight: 600;
`;

const Select = styled.select`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: "Segoe UI", Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }
`;

const StyledDatePicker = styled(DatePicker)`
  width: 335px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: "Segoe UI", Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container {
    width: 100%;
  }

  .react-datepicker__input-container input {
    width: 100%;
    padding: 8px 0;
    border: none;
    font-family: "Segoe UI", Regular;
    background: transparent;
    border-bottom: 1px solid #2b3497;
    &:focus {
      outline: none;
      border-bottom: 2px solid #2b3497;
    }
  }
  @media (max-width: 1920px) and (min-width: 1720px) {
    width: 545px;
  }
  @media (max-width: 1720px) and (min-width: 1420px) {
    width: 390px;
  }
  @media (max-width: 1420px) and (min-width: 1220px) {
    width: 300px;
  }
  @media (max-width: 1220px) and (min-width: 1020px) {
    width: 200px;
  }
`;

const ProfileCard = styled(Card)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Circle = styled.div`
  width: 131px;
  height: 131px;
  background: linear-gradient(#ffffff, #f6f6f6);
  border-radius: 50%;
  box-shadow: 0px 10px 10px #00000024;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px auto 0; /* Center align the circle */
  position: relative;
`;
const AdditionalInputContainerN = styled.div`
  margin-top: 16px;
  margin-bottom: 10px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const ProfileIcon = styled.div`
  width: 134px;
  height: 131px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2b3497;
  font-size: 30px;
  font-weight: bold;
  position: relative;
`;

const PlusIcon = styled.div`
  width: 47px;
  height: 23px;
  border-radius: 50%;
  position: absolute;
  right: 0;
  bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #bfbfbf;
  font-size: 44px;
  font-weight: 700;
`;

const ProfileText = styled.div`
  font-family: "Segoe UI", Semibold;
  font-size: 18px;
  color: #ff3030;
  margin-bottom: 20px;
  text-align: center;
`;
const VisitorPhotoHeading = styled.div`
  font-family: "Segoe UI", Semibold;
  font-size: 25px;
  font-weight: 700;
  color: #2b3497;
  text-align: center;
  margin-bottom: 10px;
`;

const PhotoButton = styled.button`
  width: 160px;
  height: 35px;
  background-color: #343d9b;
  box-shadow: 0px 10px 10px #2b349733;
  border: 2px solid #343d9b;
  border-radius: 8px;
  opacity: 1;
  color: #ffffff;
  cursor: pointer;
  margin-bottom: 20px;
`;

const ActionButton = styled.button`
  width: 160px;
  height: 35px;
  background-color: transparent;
  border: 2px solid #343d9b;
  border-radius: 8px;
  box-shadow: 0px 10px 10px #2b349733;
  opacity: 1;
  cursor: pointer;
  margin-bottom: 20px;
`;
const CheckboxRowContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  flex-direction: column;
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  color: red;
  font-family: "Segoe UI", Semibold;
  font-size: 14px;
`;

const PrivacyLink = styled.a`
  color: #2b3497;
  margin-left: 5px;
  text-decoration: none;
  cursor: pointer;
`;
const WebcamContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  overflow: hidden;
`;
const ButtonRow = styled.div`
  display: flex;
  gap: 10px; /* Adjust gap between buttons */
  margin-bottom: 20px; /* Optional: Adjust margin bottom */
  margin-top: 20px;
  justify-content: center;
`;

// Tabs container
const Tabs = styled.div`
  display: flex;
  border-bottom: 2px solid #ccc;
  margin-bottom: 20px;
`;

const Tab = styled.button`
  background: none;
  border: none;
  font-family: "Segoe UI", Semibold;
  padding: 10px 20px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  color: #000;
  &:hover {
    color: #2b3497;
  }
  ${({ active }) =>
    active &&
    `
    border-bottom: 2px solid #2B3497;
    color: #2B3497;
  `}
  ${({ disabled }) =>
    disabled &&
    `
  cursor:not-allowed;
  opacity: 0.5
  `}
`;

const TabContent = styled.div`
  display: ${({ active }) => (active ? "block" : "none")};
`;

const HeaderN = styled.h3`
  margin-top: 16px;
  color: ${(props) =>
    props.disabled ? "#a9a9a9" : "#2B3497"}; /* Change color if disabled */
`;

const DropdownContainer = styled.div`
  margin-top: 16px;
`;

const DropdownLabel = styled.label`
  font-weight: 600;
  margin-right: 8px;
`;

const StyledDropdown = styled.select`
  padding: 10px;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  background-color: #f9f9f9;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: #293495;
    outline: none;
  }

  option {
    padding: 8px;
  }
`;

const InputContainer = styled.div`
  margin-top: 16px;
  display: ${(props) => (props.show ? "flex" : "none")};
  gap: 14px;
`;

const SpinnerInput = styled.input`
  padding: 10px;
  width: 60px;
  text-align: center;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  background-color: #f9f9f9;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: #293495;
    outline: none;
  }
`;

const SpinnerInputLabel = styled.label`
  font-weight: 600;
`;

const RecurrenceInput = styled.input`
  padding: 10px;
  width: 80px;
  text-align: center;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  background-color: #f9f9f9;
  cursor: pointer;
  margin-left: 8px;

  &:focus {
    border-color: #293495;
    outline: none;
  }
`;

const AdditionalInputContainer = styled.div`
  margin-top: 16px;
  display: ${(props) => (props.show ? "flex" : "none")};
  flex-direction: column;
  align-items: flex-start;
`;
const SelectedValuesContainer = styled.div`
  margin-top: 10px;
  padding: 12px;
  background-color: #f9f9f9;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
`;

const SelectedHeader = styled.h4`
  margin-bottom: 11px;
  font-weight: bold;
  color: #293495;
`;

const ValueRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const SelectedValue = styled.div`
  font-weight: bold;
  color: #000;
`;

const SwitchContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const SwitchRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SwitchLabel = styled.label`
  font-weight: 600;
  font-size: 16px;
`;

const Switch = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const SwitchText = styled.span`
  font-weight: bold;
  margin-left: 10px;
  color: ${({ isOn }) =>
    isOn ? "#28a745" : "#6c757d"}; // Green for Yes, Gray for No
`;

const SwitchSlider = styled.div`
  width: 50px;
  height: 24px;
  background-color: ${({ isOn }) =>
    isOn ? "#28a745" : "#ccc"}; // Green for Yes, Gray for No
  border-radius: 34px;
  position: relative;
  transition: 0.4s;

  &:before {
    content: "";
    position: absolute;
    height: 20px;
    width: 20px;
    left: ${({ isOn }) =>
      isOn ? "26px" : "4px"}; // Moves the slider based on the toggle state
    bottom: 2px;
    background-color: white;
    border-radius: 50%;
    transition: 0.4s;
  }
`;

const InputFieldContainer = styled.div`
  margin-top: 20px;
`;

const InputLabel = styled.label`
  font-weight: 600;
  margin-bottom: 5px;
  display: block;
`;

const StyledTextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  resize: none;
  &:focus {
    border-color: #28a745; // Green border on focus
  }
`;

const Checkbox = styled.input`
  width: 15px; /* Increases the size of the checkbox */
  height: 15px;
  margin-right: 5px;
`;
const CheckboxLabel = styled.span`
  font-weight: 400;
  color: #000;
  font-size: 16px;
  margin-right: 8px; /* Adds space between the label and checkbox */
`;
const CheckboxContainernew = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(100px, 1fr)
  ); /* Creates responsive grid */
  gap: 5px; /* Adds space between checkboxes */
  max-width: 400px; /* Adjust the width as needed */
`;
const CheckboxLabelnew = styled.span`
  display: inline-flex;
  align-items: center; /* Ensures vertical alignment of the checkbox and text */
  gap: 8px; /* Adds space between the checkbox and text */
  font-size: 14px; /* Adjust based on your preferred font size */
  margin: 5px 0;
  font-weight: 400;
  color: #000;
`;

const PopupContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;
const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const PopupContent = styled.div`
  background: white;
  width: 500px;
  max-height: 80%;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  overflow-y: auto;
  text-align: left;
  /* Scrollbar styling */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #293495; /* Custom scrollbar thumb color */
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #ff3030; /* Hover color */
  }

  /* Firefox scrollbar */
  scrollbar-color: #293495 #f1f1f1;
  scrollbar-width: thin;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center; /* Center the button horizontally */
  margin-top: 20px;
`;

const CloseButton = styled.button`
  background-color: #293495;
  color: white;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #ff3030;
  }
`;
const PopupButton = styled.button`
  background-color: #2b3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2b349754;
  opacity: 1;
  cursor: pointer;
  margin-left: 10px; /* Add space between buttons */
  &.no-button {
    background-color: red; /* Change color to red for Close button */
  }
`;

const PopupText = styled.p`
  font-size: 18px;
  color: #2b3497;
  margin-bottom: 20px;
`;
const PopupContentN = styled.div`
  position: relative;
  background: linear-gradient(#ffffff, #f5f5f5, #ffffff);
  box-shadow: 0px 0px 1px #0000004a;
  border-radius: 30px;
  padding: 30px;
  text-align: center;
  width: 500px;
`;

const ChipContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
`;

const Chip = styled.div`
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 16px;
  padding: 5px 10px;
  margin: 2px;
  display: flex;
  align-items: center;
  font-size: 14px;
`;

const RemoveChipButton = styled.span`
  color: #ff0000;
  font-weight: bold;
  margin-left: 5px;
  cursor: pointer;
`;

const InputField = styled.input`
  border: none;
  outline: none;
  flex: 1;
  font-size: 14px;
  margin-left: 5px;
  padding: 5px;
`;

const SuggestionBox = styled.ul`
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: 5px 0 0;
  padding: 0;
  list-style: none;
  background: white;
  max-height: 150px;
  overflow-y: auto;
`;

const SuggestionItem = styled.li`
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;
const AdditionalInputContainerNN = styled.div`
  margin-top: 16px;
  margin-bottom: 10px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const FileUploadContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const HiddenFileInput = styled.input`
  display: none;
`;

const CustomFileButton = styled.button`
  background-color: #293495;
  color: #ffffff;
  padding: 8px 16px;
  font-size: 14px;
  font-family: "Segoe UI", Semibold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background-color: #1f2875;
  }
`;

const FileNameInput = styled.input`
  flex: 1;
  padding: 8px;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: "Segoe UI", Regular;
  background: transparent;
  color: #000;

  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }
`;

//css file acknowlaged
const AckItem = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 20px 12px;
  margin-bottom: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fafafa;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #f0f4ff;
  }

  input {
    margin-top: 3px;
    cursor: pointer;
  }
`;

const AckText = styled.span`
  font-size: 14px;
  color: #333;
  line-height: 1.4;

  a {
    color: #293495;
    font-weight: 500;
    text-decoration: underline;
  }
`;

const TableContainer = styled.div`
  margin-top: 20px;
  width: 100%;
  overflow-x: auto; /* makes it scrollable horizontally */
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(
    to right,
    #e6e6e6,
    #f2f2f2,
    #f5f5f5,
    #f3f3f3,
    #e9e9e9
  );
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 9px 10px;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }

  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
  font-size: 13px;
`;

const PdfModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
`;

const PdfModalContent = styled.div`
  background: #fff;
  padding: 20px;
  width: 80%;
  max-width: 900px;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #0000001a;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const CloseButtonIcon = styled.button`
  position: absolute;
  top: 4px;
  right: 15px;
  border: none;
  background: transparent;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  color: #293495;
`;

const PdfFrame = styled.iframe`
  width: 100%;
  height: 80vh;
  border: none;
  margin-top: 10px;
`;

const AgreeButton = styled.button`
  margin-top: 15px;
  align-self: flex-end;
  padding: 10px 18px;
  background: #293495;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s ease;

  &:hover {
    background: #1f276f;
  }
`;

const CheckinVisitorFormC = () => {
  const location = useLocation();
  const { checkType } = location.state || {}; // Destructure
  const { data } = location.state || {}; // Destructure
  const { code } = location.state || {}; // Destructure
  //console.log("code", code);

  // Retrieve mobileNumber from localStorage
  const navigate = useNavigate(); // Initialize useNavigate hook
  const appointmentId = localStorage.getItem("appointmentId");
  const storedMobileNumber = localStorage.getItem("mobileNumber");
  const storedVehicleNo = localStorage.getItem("vehicleNo");
  const storedMeetingOn = localStorage.getItem("meetingOn");
  const storedMeetingTo = localStorage.getItem("meetingTo");
  const storedGate = localStorage.getItem("gate");
  const storedBuilding = localStorage.getItem("building");
  const storedPurpose = localStorage.getItem("purpose");
  const storedEmpId = localStorage.getItem("employeeId"); // Retrieve empId

  const [checkinData, setCheckinData] = useState("");
  const [visitorTypes, setVisitorTypes] = useState([]);
  const [activeTab, setActiveTab] = useState("details"); // State for tab management

  const [isChecked, setIsChecked] = useState(false);
  const [recurrencePattern, setRecurrencePattern] = useState("");
  const [selectedrecurrencePattern, setSelectedrecurrencePattern] =
    useState("");
  const [recurrencePatternAPI, setRecurrencePatternAPI] = useState("");
  const [selectedDay, setSelectedDay] = useState("");
  const [selectedWeekday, setSelectedWeekday] = useState([]); // Properly initialized as an empty array
  const [selectedWeekdayAPI, setSelectedWeekdayAPI] = useState("");

  const [selectedMonth, setSelectedMonth] = useState([]); // Initialize as an empty array
  const [selectedMonthAPI, setSelectedMonthAPI] = useState("");

  const [isAllDayChecked, setIsAllDayChecked] = useState(false);
  const [recurEvery, setRecurEvery] = useState();

  const [isAssistanceRequired, setIsAssistanceRequired] = useState(false);
  const [isServiceProviderAccess, setIsServiceProviderAccess] = useState(false);
  const [isWiFiRequired, setIsWiFiRequired] = useState(false);
  const [isEscortRequired, setIsEscortRequired] = useState(false);
  const [isadditionalNotify, setIsAdditionalNotify] = useState(false);

  const [additionalMessage, setAdditionalMessage] = useState("");
  const [checkInInstructions, setCheckInInstructions] = useState("");

  const toggleAssistanceRequired = () =>
    setIsAssistanceRequired(!isAssistanceRequired);
  const toggleServiceProviderAccess = () =>
    setIsServiceProviderAccess(!isServiceProviderAccess);
  const toggleWiFiRequired = () => setIsWiFiRequired(!isWiFiRequired);
  const toggleEscortRequired = () => setIsEscortRequired(!isEscortRequired);
  const toggleadditionalNotifyRequired = () =>
    setIsAdditionalNotify(!isadditionalNotify);

  const handleAdditionalMessageChange = (e) =>
    setAdditionalMessage(e.target.value);
  const handleCheckInInstructionsChange = (e) =>
    setCheckInInstructions(e.target.value);
  const [selectedIdProofType, setSelectedIdProofType] = useState("");

  const [idProofTypes, setIdProofTypes] = useState([]);

  const [leaderCode, setleaderCode] = useState(null);
  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const sigCanvasRef = useRef(null);

  const handleCheckboxChange = () => {
    setIsChecked((prev) => !prev);
  };
  const handleDropdownChange = (event) => {
    // console.log("event.target", event.target);
    const selectedText = event.target.options[event.target.selectedIndex].text;
    //console.log("selectedText", selectedText);
    // This gets the text of the selected option

    setRecurrencePattern(event.target.value);
    if (event.target.value == "1") {
      setRecurrencePatternAPI(1);
    }
    if (event.target.value == "2") {
      setRecurrencePatternAPI(2);
    }
    if (event.target.value == "3") {
      setRecurrencePatternAPI(3);
    }
  };

  const handleAllDayCheckboxChange = () => {
    setIsAllDayChecked((prev) => !prev);
  };

  const handleRecurEveryChange = (event) => {
    setRecurEvery(event.target.value);
  };

  const getRecurrencePatternAPIValue = () => {
    switch (recurrencePattern) {
      case "1":
        return 1;
      case "2":
        return 2;
      case "3":
        return 3;
      default:
        return null; // Handle default case as needed
    }
  };

  const [formData, setFormData] = useState({
    // visitorName: '',
    firstName: "",
    middleName: "",
    lastName: "",
    emailId: "",
    gender: "",
    nationality: "",
    visitorMobile: "",
    selectedVisitorTypeId: "",
    visitorCompany: "",
    meetingFrom: null,
    meetingTo: null,
    meetingVenue: "",
    visitorAssets: "",
    vehicleNo: "",
    remarks: "",
    visitorPhoto: "",
    gate: "",
    building: "",
    CardNumber: "",
    purpose: "",
    idProofId: selectedIdProofType || 0,
    visitorIdNumber: "",
  });

  const [formErrors, setFormErrors] = useState({
    // visitorName: false,
    firstName: false,
    lastName: false,
    emailId: false,
    visitorMobile: false,
    CardNumber: false,
  });
  useEffect(() => {
    const getVisitorTypes = async () => {
      const storedEmpId = localStorage.getItem("employeeId");
      try {
        const types = await axios.get(
          `/VisitorType/GetVisitorTypeDetailsByEmpId/${storedEmpId}`,
        );
        setVisitorTypes(types.data);
      } catch (error) {
        console.error("Error fetching visitor types:", error);
      }
    };
    getVisitorTypes();
  }, []);

  const [newChek, setNewCheck] = useState();
  const [newChekN, setNewCheckN] = useState();

  useEffect(() => {
    if (data) {
      setNewCheck(data);
      setCheckinData(data);
    } else {
      console.warn(" No data found in localStorage or 'data' is undefined.");
    }
  }, [data]);

  useEffect(() => {
    const getIdProofTypes = async () => {
      try {
        const types = await fetchIdProofTypes();
        setIdProofTypes(types);
      } catch (error) {
        console.error("Error fetching visitor types:", error);
      }
    };
    getIdProofTypes();
  }, []);

  useEffect(() => {
    if (appointmentId) {
      // Function to fetch appointment data
      const fetchAppointmentData = async () => {
        try {
          //if (code === undefined) {
          //const response = await axios.get(`/VisitorDetails/GetVisitorDetailsPrePopluate?VisitorMob=${storedMobileNumber}`);
          const response = await axios.get(
            `/Appointment/GetAppointmentDetailsById/${appointmentId}`,
          );
          if (response.data.statusCode === 1 && response.data.message) {
            toast.error(response.data.message);
            return;
          }
          if (
            response.data ==
            "You are not allowed to check-in this visitortype, Please contact administrator."
          ) {
            toast.error(
              "You are not allowed to check-in this visitortype, Please contact administrator.",
            );
            return;
          }

          setNewCheck(response.data);
          if (response.status === 200) {
            setCheckinData(response.data);
          } else {
            console.error("Failed to fetch appointment data");
          }
          //  }
          // else {
          //   const formattedMobileNumber = `${code}-${storedMobileNumber}`;
          //   const response = await axios.get(`/VisitorDetails/GetVisitorDetailsPrePopluate?VisitorMob=${formattedMobileNumber}`);
          //   const responseV = await axios.get(`/Appointment/Appointments/${formattedMobileNumber}`);
          //   if (responseV.data == "You are not allowed to check-in this visitortype, Please contact administrator.") {
          //     toast.error("You are not allowed to check-in this visitortype, Please contact administrator.")
          //     return
          //   }

          //   setNewCheck(responseV.data)
          //   if (response.status === 200) {
          //     setCheckinData(response.data);
          //   } else {
          //     console.error('Failed to fetch appointment data');
          //   }

          // }
        } catch (error) {
          console.error("Error fetching appointment data:", error);
        }
      };

      const fetchAppointmentDataeemp = async () => {
        try {
          const responseeEMP = await axios.get("/Employee/");
          setEmployeeData(responseeEMP.data);
        } catch (error) {
          console.error("Error fetching appointment data:", error);
        }
      };
      const getIdProofTypes = async () => {
        try {
          const types = await fetchIdProofTypes();
          setIdProofTypes(types);
        } catch (error) {
          console.error("Error fetching visitor types:", error);
        }
      };
      fetchAppointmentDataeemp();

      fetchAppointmentData();
      getIdProofTypes();
    }
  }, []);
  const [employeeData, setEmployeeData] = useState([]); // To store the employee data
  // Run this effect only once when the component mounts
  const [fieldData, setFieldData] = useState("");

  useEffect(() => {
    if (!checkinData || visitorTypes.length === 0) return;

    if (data) {
      if (data.recurrancePattern === 1) {
        setSelectedDay(data.selectedRecurrence);
      }
      if (data.recurrancePattern == 2) {
        if (data.recurrancePattern == 2) {
          // Directly use the selectedRecurrence string as the state value
          const weekdaysArray = data.selectedRecurrence
            ? data.selectedRecurrence?.split(",").map(Number)
            : [];
          setSelectedWeekday(weekdaysArray);
        } else {
          setSelectedWeekday(""); // Reset the state when pattern is not 2
        }
      } else {
        setSelectedWeekday([]); // Reset if not in recurrence pattern 2
      }
      if (recurrencePattern === "3") {
        if (data.recurrancePattern === 3) {
          // Directly use the selectedRecurrence string as the state value
          const monthsArray = data.selectedRecurrence
            ? data.selectedRecurrence?.split(",").map(Number)
            : [];
          setSelectedMonth(monthsArray); // Set an empty string if no data
        } else {
          setSelectedMonth([]); // Reset the state when pattern is not 2
        }
      }
    }

    setIsChecked(data.repeatVisit);
    setRecurrencePattern(
      data.recurrancePattern === null
        ? null
        : data.recurrancePattern === 1
          ? "1"
          : data.recurrancePattern === 2
            ? "2"
            : "3",
    ); // Set to default value (1 for Daily)
    setSelectedDay(data.selectedRecurrence);
    setSelectedWeekday(data.selectedRecurrence);
    setSelectedMonth(data.selectedRecurrence);
    setRecurEvery(data.recurEvery);
    setIsAllDayChecked(data.allDay);
    setIsAssistanceRequired(data.assitanceRequired);
    setIsServiceProviderAccess(data.serviceProviderAccess);
    setIsWiFiRequired(data.wifiRequired);
    setIsEscortRequired(data.escort);
    setAdditionalMessage(data.messageToVisitor);
    setCheckInInstructions(data.checkinInstruction);
    setIsAdditionalNotify(data.additionalNotification);
    if (data.notifyTo) {
      setSelectedEmails(data.notifyTo?.split(",").map((email) => email.trim()));
    }
    const formatDate = (date) => {
      const padTo2Digits = (num) => num.toString().padStart(2, "0");

      return (
        date.getFullYear() +
        "-" +
        padTo2Digits(date.getMonth() + 1) +
        "-" +
        padTo2Digits(date.getDate()) +
        "T" +
        padTo2Digits(date.getHours()) +
        ":" +
        padTo2Digits(date.getMinutes()) +
        ":" +
        padTo2Digits(date.getSeconds())
      );
    };
    const currentDateTime = formatDate(new Date()); // Get the current date and time in ISO 8601 format

    const visitorTy = visitorTypes.find(
      (type) => type.id === checkinData.selectedVisitorTypeId,
    );

    setFieldData(visitorTy?.individualAppointmentInputField[0]);
    // Update formData with appointmentData fields
    setFormData({
      // visitorName: checkinData.visitorName || '',
      firstName: checkinData.firstName,
      middleName: checkinData.middleName,
      lastName: checkinData.lastName,
      gender: checkinData.gender,
      nationality: checkinData.nationality,
      emailId: checkinData.visitorEmail || "",
      visitorMobile: checkinData.visitorMobile || "",
      selectedVisitorTypeId: checkinData.selectedVisitorTypeId || "",
      visitorCompany: checkinData.visitorCompany || "",
      meetingFrom: storedMeetingOn || checkinData.meetingOn,
      meetingTo: storedMeetingTo || checkinData.meetingTo,
      meetingVenue: newChek.meetingvenue || "",
      employeeName: checkinData.hostEmail || "",
      employeeMobile: checkinData.hostMobile || "",
      vehicleNo: storedVehicleNo || checkinData.vehicleNo || "",
      visitorPhoto: checkinData.visitorPhoto || "",
      checkInId: checkinData.checkInId,
      appointmentId: checkinData.id,
      hostName: checkinData?.employeeId?.toString() || "",
      visitorPhoto: checkinData.visitorPhoto, // Bind empId to hostName
      //  checkinType:checkinData.checkinType,
      gate: checkinData.gate || "",
      building: checkinData.building || "",
      checkinType: checkType,
      checkInDateTime: currentDateTime,
      purpose: storedPurpose,
      txtFloor: `${storedPurpose}, ${storedGate}, ${storedBuilding}`,
      CardNumber: "", // Format txtFloor as a string
      idProofId: checkinData.idProofId,
      visitorIdNumber: checkinData.visitorIdNumber,
    });
    setProfileImage(`data:image/png;base64,${checkinData.visitorPhoto}`);

    const getMeetingvenues = async () => {
      try {
        const venues = await fetchMeetingVenues();
        setMeetingvenues(venues);
      } catch (error) {
        console.error("Error fetching meeting venues:", error);
      }
    };

    getMeetingvenues();
  }, [checkinData, visitorTypes]);
  const [meetingvenues, setMeetingvenues] = useState([]);
  const [gates, setGates] = useState([]);
  const [buildings, setBuildings] = useState([]);

  useEffect(() => {
    const prepopulateGateAndBuilding = async () => {
      if (!checkinData || meetingvenues.length === 0) return;

      const {
        gate,
        gateName,
        building,
        buildingName,
        gateId,
        meetingVenue,
        meetingvenue,
      } = checkinData;

      try {
        // 🟢 CASE 1: API already gave Gate & Building → use them but still fetch lists for dropdowns
        if (gate && gateName) {
          setSelectedGate({ id: gate, name: gateName });

          // Load gates list for dropdown
          const gatesRes = await axios.get(
            `/Location/GetGatesByLocationID?locationID=${checkinData.locationId}`,
          );
          const fetchedGates = gatesRes.data || [];
          setGates(fetchedGates);

          // Load buildings list for dropdown
          // const buildingsRes = await axios.get(
          //   `/Location/GetBuidingsByGateID?gateID=${gate}`,
          // );
          const buildingsResponse = await axios.get(
            `/Location/GetBuildingAndGateByLocationId/${checkinData.locationId}`,
          );
          const fetchedBuildings = buildingsResponse.data?.data?.buildings || [];
          setBuildings(fetchedBuildings);

          // Set formData with IDs
          const matchedBuilding = fetchedBuildings.find(
            (b) =>
              b.name.trim().toLowerCase() ===
              (buildingName || "").trim().toLowerCase(),
          );
          setFormData((prev) => ({
            ...prev,
            gate,
            building: matchedBuilding?.id || "",
          }));

          return;
        }

        // 🟢 CASE 2: No gate/building from API → find meetingVenue and fetch lists
        const meetingVenueName = (meetingVenue || meetingvenue || "")
          .trim()
          .toLowerCase();
        const matchedVenue = meetingvenues.find(
          (v) => v.locationName.trim().toLowerCase() === meetingVenueName,
        );

        if (!matchedVenue?.id) return;

        const gatesRes = await axios.get(
          `/Location/GetGatesByLocationID?locationID=${matchedVenue.id}`,
        );
        const fetchedGates = gatesRes.data || [];
        setGates(fetchedGates);

        const selectedGateObject = fetchedGates.find((g) => g.id === gateId);
        setSelectedGate(selectedGateObject || null);

        // if (selectedGateObject?.id) {
          // const buildingsRes = await axios.get(
          //   `/Location/GetBuidingsByGateID?gateID=${selectedGateObject.id}`,
          // );
          const buildingsResponse = await axios.get(
            `/Location/GetBuildingAndGateByLocationId/${matchedVenue.id}`,
          );
          const fetchedBuildings = buildingsResponse.data?.data?.buildings || [];
          setBuildings(fetchedBuildings);

          const matchedBuilding = fetchedBuildings.find(
            (b) =>
              b.name.trim().toLowerCase() ===
              (building || "").trim().toLowerCase(),
          );

          setFormData((prev) => ({
            ...prev,
            gate: selectedGateObject.id,
            building: matchedBuilding?.id || "",
          }));
        // }
      } catch (error) {
        console.error("Error fetching gates/buildings:", error);
      }
    };

    prepopulateGateAndBuilding();
  }, [checkinData, meetingvenues]);

  const [inputValue, setInputValue] = useState("");
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);

  const handleInputChangeE = (e) => {
    const value = e.target.value;
    if (value == "no") {
      setInputValue("");
    } else {
      setInputValue(value);
    }
  };

  const handleChipRemove = (email) => {
    if (isadditionalNotify) {
      setSelectedEmails((prev) => prev.filter((e) => e !== email));
    }
  };

  const handleKeyDown = (e) => {
    if (
      e.key === "Enter" &&
      inputValue &&
      !selectedEmails.includes(inputValue)
    ) {
      setSelectedEmails((prev) => [...prev, inputValue.trim()]);
      setInputValue("");
    }
  };
  useEffect(() => {
    // Log the selected emails to the console whenever they update
  }, [selectedEmails]);
  const [getCheckID, setGetCheckId] = useState("");

  const handleDayChange = (event) => {
    setSelectedDay(event.target.value);
  };
  const handleWeekdayCheckboxChange = (weekday) => {
    setSelectedWeekday((prevSelectedWeekdays) => {
      const updatedWeekdays = prevSelectedWeekdays.includes(weekday)
        ? prevSelectedWeekdays.filter((day) => day !== weekday) // Remove if already selected
        : [...prevSelectedWeekdays, weekday]; // Add if not selected

      return updatedWeekdays;
    });
  };
  const handleMonthCheckboxChange = (month) => {
    setSelectedMonth((prevSelectedMonths) => {
      // Toggle the presence of the month in the selectedMonths array
      const updatedMonths = prevSelectedMonths.includes(month)
        ? prevSelectedMonths.filter((m) => m !== month) // Remove if already selected
        : [...prevSelectedMonths, month]; // Add if not selected

      return updatedMonths;
    });
  }; // Run this effect whenever checkinData changes
  const handleResetAcknowledgement = () => {
    setAckChecklist((prev) =>
      Object.fromEntries(Object.keys(prev).map((key) => [key, false])),
    );
    setNdaDocumentFileName("");
    setNdaDocument("");
  };

  const handleReset = () => {
    setIsCheckedB(false);
    setIsCheckedP(false);
    setIsCheckedC(false);
    // setFormData({
    //   // visitorName: '',
    //   // visitorEmail: '',
    //   // visitorMobile: '',
    //   // visitorCompany: '',
    //   // meetingFrom: storedMeetingOn,
    //   // meetingTo: storedMeetingTo,
    //   visitorAssets: '',
    //   vehicleno: '',
    //   remarks: '',
    // });
    setFormData((prevFormData) => ({
      ...prevFormData, // Spread the existing state to retain other fields
      visitorAssets: "",
      purpose: "",
      // vehicleno: '',
      remarks: "",
      CardNumber: "",
    }));
    setFormErrors({
      // visitorName: false,
      // emailId: false,
      // visitorMobile: false,
    });
    // console.log('Form reset');
  };

  const [showQRCode, setShowQRCode] = useState(false);
  const [qrCodeValue, setQrCodeValue] = useState("");
  const visitorPassRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => visitorPassRef.current,
    onAfterPrint: () => {
      // Navigate after printing
      navigate("/layout/Dashboard/Dashboard");
    },
    documentTitle: "Visitor Pass", // Optional: Set the title for the printed document
  });

  const handleChange = async (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: false,
      });
    }
  };
  const [transportVendorFileName, setTransportVendorFileName] = useState("");
  const [transportVendorFileBase64, setTransportVendorFileBase64] =
    useState("");

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) {
        resolve(null);
        return;
      }

      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(",")[1]); // remove "data:...base64,"
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const handleNext = async (event) => {
    event.preventDefault();

    let valid = true;
    const errors = {};

    if (!data?.entityId) {
      toast.error("Entity ID is missing");
      return;
    }

    if (fieldData.visitorNameField && formData.firstName === "") {
      errors.firstName = true;
      valid = false;
    }
    if (fieldData.visitorNameField && formData.lastName === "") {
      errors.lastName = true;
      valid = false;
    }
    if (fieldData.visitorEmailField && formData.visitorEmail === "") {
      errors.visitorEmail = true;
      valid = false;
    }
    if (fieldData.genderField && formData.gender === "") {
      errors.gender = true;
      valid = false;
    }
    if (fieldData.visitorMobileField && formData.visitorMobile === "") {
      errors.visitorMobile = true;
      valid = false;
    }
    if (formData.selectedVisitorTypeId === "") {
      errors.selectedVisitorTypeId = true;
      valid = false;
    }
    if (fieldData.purpose && formData.purpose === "") {
      errors.purpose = true;
      valid = false;
    }
    if (fieldData.locationField && formData.meetingVenue === "") {
      errors.meetingvenue = true;
      valid = false;
    }
    if (fieldData.gateField && formData.gate === "") {
      errors.gate = true;
      valid = false;
    }
    if (fieldData.nationalityField && formData.nationality === "") {
      errors.nationality = true;
      valid = false;
    }
    if (fieldData.areaField && formData.building === "") {
      errors.building = true;
      valid = false;
    }
    if (fieldData.idProofTypeField && formData.idProofId === "") {
      errors.idProofId = true;
      valid = false;
    }
    if (fieldData.idProofNumberField && formData.visitorIdNumber === "") {
      errors.visitorIdNumber = true;
      valid = false;
    }
    if (formData.emailId !== "") {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(formData.emailId)) {
        errors.emailId = true;
        valid = false;
      }
    }

    // if (formData.visitorMobile !== '') {
    //   const mobilePattern = /^\d{10}$/;
    //   if (!mobilePattern.test(formData.visitorMobile)) {
    //     errors.visitorMobile = true;
    //     valid = false;
    //   }
    // }
    if (isCheckedB) {
      if (!formData.visitorAssets) {
        errors.visitorAssets = "Please fill the asset field";
        valid = false;
      }
    }
    if (isCheckedB) {
      if (!formData.remarks) {
        errors.remarks = "Please fill the remark field";
        valid = false;
      }
    }
    if (!valid) {
      setActiveTab("details");
      setFormErrors(errors);
      toast.error("Please fill all the mandatory  fields.");
      return;
    } else if (isCheckedP && isCheckedC) {
      setDetailsValid(true);
      setActiveTab("acknowledge");
    } else {
      setActiveTab("details");
      toast.error("Please verify the privacy and covid fitness");
    }
  };

  const messages = {
    training: "Please agree to the Training Video acknowledgment.",
    safetyVideo: "Please agree to the Safety Video acknowledgment.",
    safetyDoc: "Please agree to the Safety Document acknowledgment.",
    ndaDoc: "Please agree to the NDA Document.",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let valid = true;
    const errors = {};

    if (!data?.entityId) {
      toast.error("Entity ID is missing");
      return;
    }

    if (fieldData.visitorNameField && formData.firstName === "") {
      errors.firstName = true;
      valid = false;
    }
    if (fieldData.visitorNameField && formData.lastName === "") {
      errors.lastName = true;
      valid = false;
    }
    if (fieldData.visitorEmailField && formData.visitorEmail === "") {
      errors.visitorEmail = true;
      valid = false;
    }
    if (fieldData.genderField && formData.gender === "") {
      errors.gender = true;
      valid = false;
    }
    if (fieldData.visitorMobileField && formData.visitorMobile === "") {
      errors.visitorMobile = true;
      valid = false;
    }
    if (formData.selectedVisitorTypeId === "") {
      errors.selectedVisitorTypeId = true;
      valid = false;
    }
    if (fieldData.purpose && formData.purpose === "") {
      errors.purpose = true;
      valid = false;
    }
    if (fieldData.locationField && formData.meetingVenue === "") {
      errors.meetingvenue = true;
      valid = false;
    }
    if (fieldData.gateField && formData.gate === "") {
      errors.gate = true;
      valid = false;
    }
    if (fieldData.nationalityField && formData.nationality === "") {
      errors.nationality = true;
      valid = false;
    }
    if (fieldData.areaField && formData.building === "") {
      errors.building = true;
      valid = false;
    }
    if (fieldData.idProofTypeField && formData.idProofId === "") {
      errors.idProofId = true;
      valid = false;
    }
    if (fieldData.idProofNumberField && formData.visitorIdNumber === "") {
      errors.visitorIdNumber = true;
      valid = false;
    }
    if (formData.emailId !== "") {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(formData.emailId)) {
        errors.emailId = true;
        valid = false;
      }
    }

    // if (formData.visitorMobile !== '') {
    //   const mobilePattern = /^\d{10}$/;
    //   if (!mobilePattern.test(formData.visitorMobile)) {
    //     errors.visitorMobile = true;
    //     valid = false;
    //   }
    // }
    if (isCheckedB) {
      if (!formData.visitorAssets) {
        errors.visitorAssets = "Please fill the asset field";
        valid = false;
      }
    }
    if (isCheckedB) {
      if (!formData.remarks) {
        errors.remarks = "Please fill the remark field";
        valid = false;
      }
    }

    for (const key in ackChecklist) {
      console.log("key value", key);
      if (ackChecklist[key] === false) {
        setActiveTab("acknowledge");
        toast.error(messages[key]);
        return;
      }
    }

    if (!valid) {
      setActiveTab("details");
      setFormErrors(errors);
      toast.error("Please fill all the mandatory  fields.");
      return;
    } else if (isCheckedP && isCheckedC) {
      try {
        // Send form data to /api/VisitorDetails

        let recurrencePattern = getRecurrencePatternAPIValue();

        let newSelectedRecurrencePattern = "";

        // Determine the selected recurrence pattern based on the recurrencePatternAPI value
        if (recurrencePattern === 1) {
          newSelectedRecurrencePattern = "";
        } else if (recurrencePattern === 2) {
          newSelectedRecurrencePattern = selectedWeekday;
        } else if (recurrencePattern === 3) {
          newSelectedRecurrencePattern = selectedMonth;
        }

        // Log the new selected recurrence pattern before setting the state
        const formDataAdditional = {
          repeatVisit: isChecked,
          recurrencePattern: recurrencePattern,
          selectedRecurrence: String(newSelectedRecurrencePattern),
          selectedDay: selectedDay,
          selectedWeekday: selectedWeekdayAPI,
          selectedMonth: selectedMonthAPI,
          recurEvery: recurEvery,
          isAllDay: isAllDayChecked,
          assistanceRequired: isAssistanceRequired,
          serviceProviderAccess: isServiceProviderAccess,
          wifiRequired: isWiFiRequired,
          escortRequired: isEscortRequired,
          additionalNotification: isadditionalNotify,
          additionalMessage: additionalMessage,
          checkInInstructions: checkInInstructions,
        };

        const formattedEmails = selectedEmails?.join(", ");
        if (formDataAdditional.repeatVisit == 1) {
          const formattedData = {
            ...formData,
            visitorName: formData.firstName,
            nationalityCode: checkinData.nationalityCode,
            locationId: parseInt(checkinData.locationId, 10),
            CardNumber: formData.CardNumber || "0",
            assitanceRequired: formDataAdditional.assistanceRequired,
            serviceProviderAccess: formDataAdditional.serviceProviderAccess,
            wifiRequired: formDataAdditional.wifiRequired,
            escort: formDataAdditional.escortRequired,
            additionalNotification: formDataAdditional.additionalNotification,
            notifyTo: formattedEmails,
            messageToVisitor: formDataAdditional.additionalMessage,
            checkinInstruction: formDataAdditional.checkInInstructions,
            allDay: formDataAdditional.isAllDay,
            repeatVisit: formDataAdditional.repeatVisit,
            recurrancePattern: formDataAdditional.recurrencePattern,
            recurEvery: parseInt(formDataAdditional.recurEvery, 10),
            selectedRecurrence: formDataAdditional.selectedRecurrence,
            uploadDocument: transportVendorFileBase64,
            NdaDocument: ndaDocumnet,
          };
          const responseN = await axios.post("/VisitorDetails", formattedData);

          if (responseN.status == 200) {
            const checkInId = responseN.data.checkInId;
            const Stat = "IN";
            const AppId = checkinData.id;
            if (responseN.data.statusCode == 1) {
              toast.error(
                "Check-in time is outside the allowed meeting date range.!",
              );
              // Delay navigation to ensure the toast is displayed
              setTimeout(() => {
                navigate("/layout/Dashboard/Dashboard");
              }, 3000);
              return;
            }
            console.log("Status Code", responseN?.data?.statusCode);

            if (responseN?.data?.statusCode == -1) {
              toast.error(responseN?.data?.message);
              // Delay navigation to ensure the toast is displayed
              return;
            }

            const updateAppoinmentStatus = await axios.post(
              `/Appointment/AppointStatusUpd/${AppId},${Stat}`,
            );
            console.log("update AppoinmentStatus API:", updateAppoinmentStatus);

            // Fetch visitor details using the check-in ID
            const visitorResponse = await axios.get(
              `/VisitorDetails/${checkInId}`,
            );
            const storedEmpId = localStorage.getItem("employeeId");
            const responseE = await axios.get(`/Employee/${storedEmpId}`);
            const checkinDataN = responseE.data;

            const getEmp = localStorage.getItem("employeeName");
            // const updatedFormData = {
            //   toAddress: checkinDataN.employeeMailId,
            //   mailSubject: "Visitor Check-In",
            //   visitorCompany: formData.company,
            //   visitorName: formData.visitorName,
            //   hostName: checkinData.hostName,
            //   mailType: "CHKINVISITOR",
            //   visitorMobile: formData.visitorMobile,
            //   meetingVenue: formData.meetingVenue,

            // }// Assuming response contains the check-in ID
            // const updateMail = await axios.post('/Mail', updatedFormData);
            // const updatedFormDataV = {
            //   toAddress: formData.emailId,
            //   mailSubject: "Visitor Check-In",
            //   visitorCompany: formData.company,
            //   visitorName: formData.visitorName,
            //   hostName: checkinData.hostName,
            //   mailType: "CHKINVISITOR",
            //   visitorMobile: formData.visitorMobile,
            //   meetingVenue: formData.meetingVenue,

            // }// Assuming response contains the check-in ID
            // const updateMailV = await axios.post('/Mail', updatedFormDataV);
            if (visitorResponse.status === 200) {
              const encodedId = encodeCheckInId(checkInId);
              const decodedId = decodeCheckInId(encodedId);
              // if (isCheckedB) {
              //   const formattedData = `${encodedId}`;
              //   setQrCodeValueV(formattedData);
              //   setGetCheckId(encodedId)
              //   setShowQRCode(true);

              // } else {
              const generateQRCode = () => {
                const formattedData = `${encodedId}`;
                setQrCodeValueV(formattedData);
                setGetCheckId(encodedId);
              };
              generateQRCode();
              setQrCodeValueV(generateQRCode.formattedData);
              setGetCheckId(encodedId);
              printQRCodeV(encodedId);

              //   }
            } else {
              console.error("Failed to fetch visitor details");
            }
          } else {
            console.error("Failed to submit form");
          }
        } else {
          const formattedData = {
            ...formData,
            nationalityCode: checkinData.nationalityCode,
            visitorName: formData.firstName,
            locationId: parseInt(checkinData.locationId, 10),
            CardNumber: formData.CardNumber || "0",
            assitanceRequired: formDataAdditional.assistanceRequired,
            serviceProviderAccess: formDataAdditional.serviceProviderAccess,
            wifiRequired: formDataAdditional.wifiRequired,
            escort: formDataAdditional.escortRequired,
            additionalNotification: formDataAdditional.additionalNotification,
            notifyTo: formattedEmails,
            messageToVisitor: formDataAdditional.additionalMessage,
            checkinInstruction: formDataAdditional.checkInInstructions,
            uploadDocument: transportVendorFileBase64,
            NdaDocument: ndaDocumnet,
          };
          const responseN = await axios.post("/VisitorDetails", formattedData);
          if (responseN.data.statusCode == 1) {
            toast.error(
              "Check-in time is outside the allowed meeting date range.!",
            );
            // Delay navigation to ensure the toast is displayed
            setTimeout(() => {
              navigate("/layout/Dashboard/Dashboard");
            }, 3000);
            return;
          }
          console.log("Status Code", responseN?.data?.statusCode);

          if (responseN?.data?.statusCode == -1) {
            toast.error(responseN?.data?.message);
            // Delay navigation to ensure the toast is displayed
            return;
          }

          const storedEmpId = localStorage.getItem("employeeId");
          const responseE = await axios.get(`/Employee/${storedEmpId}`);
          const checkinDataN = responseE.data;

          const getEmp = localStorage.getItem("employeeName");
          // const updatedFormData = {
          //   toAddress: checkinDataN.employeeMailId,
          //   mailSubject: "Visitor Check-In",
          //   visitorCompany: formData.company,
          //   visitorName: formData.visitorName,
          //   hostName: checkinData.hostName,
          //   mailType: "CHKINVISITOR",
          //   visitorMobile: formData.visitorMobile,
          //   meetingVenue: formData.meetingVenue,

          // }// Assuming response contains the check-in ID
          // const updateMail = await axios.post('/Mail', updatedFormData);
          // const updatedFormDataV = {
          //   toAddress: formData.emailId,
          //   mailSubject: "Visitor Check-In",
          //   visitorCompany: formData.company,
          //   visitorName: formData.visitorName,
          //   hostName: checkinData.hostName,
          //   mailType: "CHKINVISITOR",
          //   visitorMobile: formData.visitorMobile,
          //   meetingVenue: formData.meetingVenue,

          // }// Assuming response contains the check-in ID
          // const updateMailV = await axios.post('/Mail', updatedFormDataV);
          //   console.log("checkin data", checkinData)

          if (responseN.status === 200) {
            const checkInId = responseN.data.checkInId;
            const encodedId = encodeCheckInId(checkInId);
            const decodedId = decodeCheckInId(encodedId);
            const Stat = "IN";
            const AppId = checkinData.id;
            //const AppId = checkinData.id
            setGetCheckId(encodedId);
            if (responseN.data.statusCode == 1) {
              toast.error(
                "Check-in time is outside the allowed meeting date range.!",
              );
              // Delay navigation to ensure the toast is displayed
              setTimeout(() => {
                navigate("/layout/Dashboard/Dashboard");
              }, 3000);
              return;
            }

            const updateAppoinmentStatus = await axios.post(
              `/Appointment/AppointStatusUpd/${AppId},${Stat}`,
            );
            console.log("update AppoinmentStatus API:", updateAppoinmentStatus);

            // Fetch visitor details using the check-in ID
            const visitorResponse = await axios.get(
              `/VisitorDetails/${checkInId}`,
            );
            const getEmp = localStorage.getItem("employeeName");
            if (visitorResponse.status === 200) {
              const encodedId = encodeCheckInId(checkInId);
              const decodedId = decodeCheckInId(encodedId);
              // if (isCheckedB) {
              //   const formattedData = `${encodedId}`;
              //   setQrCodeValueV(formattedData);
              //   setGetCheckId(encodedId)
              //   setShowQRCode(true);

              // } else {
              const generateQRCode = () => {
                const formattedData = `${encodedId}`;
                setQrCodeValueV(formattedData);
              };
              generateQRCode();
              setGetCheckId(encodedId);
              setQrCodeValueV(generateQRCode.formattedData);
              printQRCodeV(encodedId);
              // }
            } else {
              console.error("Failed to fetch visitor details");
            }
          } else {
            console.error("Failed to submit form");
          }
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    } else {
      setActiveTab("details");
      toast.error("Please verify the privacy and covid fitness");
    }
  };

  function encodeCheckInId(checkInId) {
    // Mapping digits to specific encoded pairs
    const digitMapping = {
      1: "515253",
      3: "303030",
      5: "505050",
      2: "202020",
      4: "868484",
      6: "606060",
      7: "707070",
      8: "808080",
      9: "909090",
      0: "000000",
    };

    // Convert the Check-In ID to a string and map each digit to its corresponding encoding
    const checkInIdStr = checkInId.toString();
    const encoded = checkInIdStr
      .split("") // Split into individual digits
      .map((digit) => digitMapping[parseInt(digit)]) // Map digits to encoded values
      .join(""); // Join all the parts to form the final encoded string

    return encoded;
  }
  function decodeCheckInId(qrcode) {
    // Mapping encoded byte pairs back to digits
    const reverseMapping = {
      515253: "1",
      303030: "3",
      505050: "5",
      202020: "2",
      868484: "4",
      606060: "6",
      707070: "7",
      808080: "8",
      909090: "9",
      "000000": "0",
    };

    let checkInId = "";

    // Loop through the qrcode string in steps of 6 characters (each code is 6 characters long)
    for (let i = 0; i < qrcode.length; i += 6) {
      const segment = qrcode.substring(i, i + 6); // Extract each 6-character segment
      checkInId += reverseMapping[segment]; // Map the segment back to the corresponding digit
    }

    return checkInId; // Return the decoded check-in ID
  }
  function encryptMobileNumber(mobile) {
    let encryptedNumber = "";

    // Iterate over each digit of the mobile number
    for (let i = 0; i < mobile.length; i++) {
      // Convert the digit to its ASCII code and pad it to two digits
      const asciiCode = mobile[i].charCodeAt(0).toString().padStart(2, "0");
      encryptedNumber += asciiCode; // Concatenate to the encrypted string
    }

    return encryptedNumber;
  }
  const qrCodeRef = useRef(); // Create a ref to access the QR code canvas

  const printer = async () => {
    printQRCode();
    printQRCodeV(getCheckID);
  };
  const printQRCode = async () => {
    // Create a new iframe element
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);

    // Convert QR code to data URL
    const qrCodeDataUrlV = qrCodeRefV.current?.toDataURL();

    // Fetch the SVG image and convert to base64
    const response = await fetch(centerImage);
    const blob = await response.blob();
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64Svg = reader.result;

      // Write the content into the iframe
      const doc = iframe.contentWindow.document;
      doc.open();

      doc.write(`
        <html>
          <head>
            <title>Print QR Code</title>
            <style>
              /* Reset default print margins */
              @page { margin: 0; }
              body {
                font-family: Arial, sans-serif;
                margin: 20px;
                display: flex;
                flex-direction: column;
                align-items: center;
              }
              h2 {
                font-size: 1.5em;
                margin: 10px 0;
              }
              .visitor-label, .baggage-label {
                display: inline-block;
                background-color: #FF7A00;
                padding: 5px;
                width:300px;
                color: #FFF;
                font-weight: bold;
                font-size: 1.2em;
                margin: 10px 0;
                text-align: center;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
              p {
                font-size: 0.8em;
                color: #888;
              }
              img {
                max-width: 100%;
                margin: 10px 0;
              }
            </style>
          </head>
          <body>
            <!-- SVG Image Above Header -->
            <div style="text-align: center; margin-bottom: 10px;">
              <img src="${base64Svg}" alt="Infosys Logo" style="width: 170px; height: 100px;" />
            </div>
  
            <h2>${[formData.firstName, formData.middleName, formData.lastName].filter(Boolean).join(" ")}</h2>
            <div class="visitor-label">VISITOR</div>
            <img src="${qrCodeDataUrlV}" alt="QR Code" />
            <div class="baggage-label">BAGGAGE TAG</div>
            <p>Visitor Management System</p>
          </body>
        </html>
      `);
      doc.close();

      // Use onload event to ensure the content and styles are fully loaded before printing
      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow.print();
          document.body.removeChild(iframe); // Remove the iframe after printing
        }, 500); // Slight delay for style rendering
      };
    };
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: false,
    }));
  };

  const webcamRef = useRef(null);
  const [isCameraOn, setIsCameraOn] = useState(false);
  const [buttonLabel, setButtonLabel] = useState("Take photo");
  const [profileImage, setProfileImage] = useState(null);
  const handleCapture = async () => {
    if (!isCameraOn) {
      setIsCameraOn(true);
      setButtonLabel("Capture");
    } else {
      const imageSrc = webcamRef.current.getScreenshot();
      if (!imageSrc) return;

      const img = new Image();
      img.src = imageSrc;

      img.onload = async () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        // Initialize Face Detection
        const faceDetection = new FaceDetection({
          locateFile: (file) =>
            `https://cdn.jsdelivr.net/npm/@mediapipe/face_detection/${file}`,
        });

        faceDetection.setOptions({
          model: "short", // fast + accurate model
          minDetectionConfidence: 0.5,
        });

        await faceDetection.initialize();

        // Run face detection
        const detectionResults = await new Promise((resolve) => {
          faceDetection.onResults(resolve);
          faceDetection.send({ image: img });
        });

        // Check if face is detected
        if (
          !detectionResults.detections ||
          detectionResults.detections.length === 0
        ) {
          toast.error("Human face not detected");
          return;
        }

        // Face detected: proceed with segmentation
        const segmentation = new SelfieSegmentation({
          locateFile: (file) =>
            `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`,
        });

        segmentation.setOptions({
          modelSelection: 1,
        });

        await segmentation.initialize();

        const segmentationResults = await new Promise((resolve) => {
          segmentation.onResults(resolve);
          segmentation.send({ image: img });
        });

        // Create output canvas
        const outputCanvas = document.createElement("canvas");
        outputCanvas.width = img.width;
        outputCanvas.height = img.height;
        const outputCtx = outputCanvas.getContext("2d");

        outputCtx.drawImage(img, 0, 0);
        outputCtx.globalCompositeOperation = "destination-in";
        outputCtx.drawImage(
          segmentationResults.segmentationMask,
          0,
          0,
          img.width,
          img.height,
        );

        outputCtx.globalCompositeOperation = "destination-over";
        outputCtx.fillStyle = "transparent";
        outputCtx.fillRect(0, 0, img.width, img.height);

        const base64Image = outputCanvas.toDataURL("image/png");

        setProfileImage(base64Image);
        setFormData((prevData) => ({
          ...prevData,
          visitorPhoto: base64Image.split(",")[1],
        }));

        console.log("Processed Image (Base64):", base64Image);
      };

      setIsCameraOn(false);
      setButtonLabel("Take photo");
    }
  };

  // const handleCapture = async () => {
  //   if (!isCameraOn) {
  //     // Turn on the camera
  //     setIsCameraOn(true);
  //     setButtonLabel("Capture");
  //   } else {
  //     // Capture the webcam image
  //     const imageSrc = webcamRef.current.getScreenshot();
  //     console.log("Captured Image:", imageSrc);

  //     if (imageSrc) {
  //       // Create an image element from the captured image
  //       const img = new Image();
  //       img.src = imageSrc;

  //       img.onload = async () => {
  //         // Create a canvas for image processing
  //         const canvas = document.createElement("canvas");
  //         canvas.width = img.width;
  //         canvas.height = img.height;
  //         const ctx = canvas.getContext("2d");

  //         // Draw the captured image on the canvas
  //         ctx.drawImage(img, 0, 0, img.width, img.height);

  //         // Initialize MediaPipe Selfie Segmentation
  //         const segmentation = new SelfieSegmentation({
  //           locateFile: (file) =>
  //             `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`,
  //         });

  //         segmentation.setOptions({
  //           modelSelection: 1, // General-purpose face segmentation model
  //         });

  //         // Perform segmentation
  //         await segmentation.initialize();
  //         const results = await new Promise((resolve) => {
  //           segmentation.onResults(resolve);
  //           segmentation.send({ image: img });
  //         });

  //         // Create a canvas for output
  //         const outputCanvas = document.createElement("canvas");
  //         outputCanvas.width = img.width;
  //         outputCanvas.height = img.height;
  //         const outputCtx = outputCanvas.getContext("2d");

  //         // Draw the original image
  //         outputCtx.drawImage(img, 0, 0, img.width, img.height);

  //         // Apply the segmentation mask
  //         outputCtx.globalCompositeOperation = "destination-in"; // Retain only the face
  //         outputCtx.drawImage(
  //           results.segmentationMask,
  //           0,
  //           0,
  //           img.width,
  //           img.height
  //         );

  //         // Reset the operation and apply a transparent background
  //         outputCtx.globalCompositeOperation = "destination-over";
  //         outputCtx.fillStyle = "transparent"; // Transparent background
  //         outputCtx.fillRect(0, 0, img.width, img.height);

  //         // Convert the processed image to Base64
  //         const base64Image = outputCanvas.toDataURL("image/png");

  //         // Set the profile image and form data
  //         setProfileImage(base64Image); // Display the processed image
  //         setFormData((prevData) => ({
  //           ...prevData,
  //           visitorPhoto: base64Image.split(",")[1], // Store Base64 (excluding metadata)
  //         }));

  //         console.log("Processed Image (Base64):", base64Image);
  //       };
  //     }

  //     // Turn off the camera and reset the button label
  //     setIsCameraOn(false);
  //     setButtonLabel("Take photo");
  //   }
  // };

  // Function to handle image upload from the file input
  const handleImageUpload = async (e) => {
    const file = e.target.files[0]; // Get the uploaded file
    if (!file || (file.type !== "image/png" && file.type !== "image/jpeg")) {
      toast.error("Please upload a PNG or JPEG image");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = async () => {
      const img = new Image();
      img.src = reader.result;

      img.onload = async () => {
        // Create a canvas for image processing
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");

        // Draw the uploaded image on the canvas
        ctx.drawImage(img, 0, 0, img.width, img.height);

        // Initialize MediaPipe Selfie Segmentation
        const segmentation = new SelfieSegmentation({
          locateFile: (file) =>
            `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`,
        });

        segmentation.setOptions({
          modelSelection: 1, // General-purpose face segmentation model
        });

        // Perform segmentation
        await segmentation.initialize();
        const results = await new Promise((resolve) => {
          segmentation.onResults(resolve);
          segmentation.send({ image: img });
        });

        // Create a canvas for output
        const outputCanvas = document.createElement("canvas");
        outputCanvas.width = img.width;
        outputCanvas.height = img.height;
        const outputCtx = outputCanvas.getContext("2d");

        // Draw the original image
        outputCtx.drawImage(img, 0, 0, img.width, img.height);

        // Apply the segmentation mask
        outputCtx.globalCompositeOperation = "destination-in"; // Retain only the face
        outputCtx.drawImage(
          results.segmentationMask,
          0,
          0,
          img.width,
          img.height,
        );

        // Reset the operation and apply a transparent background
        outputCtx.globalCompositeOperation = "destination-over";
        outputCtx.fillStyle = "transparent"; // Transparent background
        outputCtx.fillRect(0, 0, img.width, img.height);

        // Convert the processed image to Base64
        const base64Image = outputCanvas.toDataURL("image/png");

        // Update the processed image in state and form data
        setProfileImage(base64Image); // Display the processed image
        setFormData({ ...formData, visitorPhoto: base64Image.split(",")[1] });
        console.log("base64Image", base64Image.split(",")[1]);
        // Save Base64 (excluding metadata)
      };
    };

    reader.readAsDataURL(file); // Read the file as base64
  };
  const closeQRCodePopup = () => {
    printQRCodeV();
    setShowQRCode(false);
    navigate("/layout/Dashboard/Dashboard");
  };

  const [isPopupVisiblePrivacy, setPopupVisiblePrivacy] = useState(false);
  const [isPopupVisibleCovid, setPopupVisibleCovid] = useState(false);
  const [isCheckedB, setIsCheckedB] = useState(false);
  const [isCheckedP, setIsCheckedP] = useState(false);
  const [isCheckedC, setIsCheckedC] = useState(false);
  const [disabled, setDisabled] = useState(true); // Initialize disabled state
  // Add state to track checkbox
  // Add state to track checkbox
  // Add state to track checkbox

  const handlePrivacyLinkClickPrivacy = () => {
    setPopupVisiblePrivacy(true);
  };

  const handleClosePopupPrivacy = () => {
    setPopupVisiblePrivacy(false);
  };

  const handlePrivacyLinkClickCovid = () => {
    setPopupVisibleCovid(true);
  };

  const handleClosePopupCovid = () => {
    setPopupVisibleCovid(false);
  };
  const handleCheckboxChangeB = (event) => {
    setIsCheckedB(event.target.checked);
  };
  const handleCheckboxChangeP = (event) => {
    setIsCheckedP(event.target.checked);
  };
  const handleCheckboxChangeC = (event) => {
    setIsCheckedC(event.target.checked);
  };
  const [showQRCodeV, setShowQRCodeV] = useState(false);
  const [qrCodeValueV, setQrCodeValueV] = useState("");
  const closeQRCodePopupV = () => {
    // setShowQRCodeV(false);
    printQRCodeV(getCheckID);
    navigate("/layout/Dashboard/Dashboard");
  };
  const qrCodeRefV = useRef(); // Create a ref to access the QR code canvas

  const [baggageTag, setBaggageTag] = useState("");
  const [showBaggageTag, setShowBaggageTag] = useState(false);
  const [detailsVisitor, setDetailsVisitor] = useState({});

  useEffect(() => {
    // Expose global function for HTML buttons
    window.baggageTagClose = () => {
      setShowBaggageTag(false); // hide popup if needed
      handleReprintPassBoth(detailsVisitor);
    };

    window.baggageTagPrint = () => {
      if (!baggageTag) {
        console.warn("No baggage tag data to print");
        return;
      }

      // ✅ Create a hidden iframe for printing
      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      document.body.appendChild(iframe);

      // ✅ Set the onload handler BEFORE writing document
      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow.print();
          document.body.removeChild(iframe);
        }, 500);
      };

      // ✅ Write baggageTag HTML into the iframe
      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(`
        <html>
          <head>
            <title>Baggage Tag</title>
            <style>
                @page { size: auto; margin: 0; }
                @media print {
                  body { margin: 0 !important; padding: 0 !important; }
                  * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
                }
            </style>
          </head>
          <body>
            ${baggageTag}
          </body>
        </html>
        `);

      doc.close();
    };
  }, [detailsVisitor, baggageTag]);

  const printQRCodeV = async (getData) => {
    // Create a new iframe element
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);

    // Convert QR code to data URL
    const formattedData = `${getData || getCheckID}`;
    const qrCodeDataUrlV = await generateQRCodeDataUrl(formattedData);

    const decodedId = decodeCheckInId(getData || getCheckID);
    console.log("Decoded:", decodedId);
    const responseWV = await axios.get(`/VisitorDetails/${decodedId}`);
    const details = responseWV.data;

    // Ensure details is always an array
    const detailsArray = Array.isArray(details) ? details : [details];

    for (const detail of detailsArray) {
      if (!detail.badgeFront && !detail.badgeBack) {
        toast.warning("No visitor pass available.");
        setTimeout(() => navigate("/layout/Dashboard/Dashboard"), 1500); // wait 1.5s
        return;
      }

      //  If baggageTag exists → show it first, store iframe for later
      if (detail.baggageTag && isCheckedB) {
        console.log(detail.baggageTag);
        setBaggageTag(detail.baggageTag);
        setDetailsVisitor(detail);
        setShowBaggageTag(true);
      } else {
        handleReprintPassBoth(detail);
      }
    }
  };

  const handleReprintPassBoth = async (detail) => {
    try {
      // Create hidden iframe
      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      document.body.appendChild(iframe);

      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(`
        <html>
          <head>
            <title>Visitor Pass</title>
            <style>
              @page { margin: 0; }
              body { 
                margin: 0; 
                display: flex; 
                justify-content: space-around;
                align-items: flex-start;
                padding: 5px;
              }
              .badge {
                margin: 10px;
                width: 8cm;      /* fixed width */
                height: 49cm;    /* tall enough for content */
                box-sizing: border-box;
              }
              @media print {
                .no-print { display: none; }
              }
            </style>
          </head>
          <body>
            <div class="badge">
              ${detail.badgeFront || ""}
            </div>
            <div class="badge">
              ${detail.badgeBack || ""}
            </div>
          </body>
        </html>
      `);
      doc.close();

      // Use onload event to ensure the content and styles are fully loaded before printing
      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow.print();
          document.body.removeChild(iframe); // Remove the iframe after printing
        }, 500);
        navigate("/layout/Dashboard/Dashboard");
        // Slight delay for style rendering
      };
    } catch (error) {
      console.error("Error in printQRCodeV:", error);
    }
  };

  // const printQRCodeV = async (getData) => {
  //   // Create a new iframe element
  //   const iframe = document.createElement('iframe');
  //   iframe.style.position = 'absolute';
  //   iframe.style.width = '0';
  //   iframe.style.height = '0';
  //   iframe.style.border = 'none';
  //   document.body.appendChild(iframe);

  //   // Convert QR code to data URL
  //   const formattedData = `${getData || getCheckID}`;
  //   const qrCodeDataUrlV = await generateQRCodeDataUrl(formattedData);

  //   const decodedId = decodeCheckInId(getData || getCheckID);
  //   console.log("Decoded:", decodedId);
  //   const responseWV = await axios.get(`/VisitorDetails/${decodedId}`);
  //   const responseTemplate = await axios.get('User/GetTemplate');

  //   console.log("responseTemplate", responseTemplate.data);

  //   if (!qrCodeDataUrlV) {
  //     console.error('QR Code data URL not generated.');
  //     return;
  //   }
  //   const formatDateTime = (datetimeString) => {
  //     const date = new Date(datetimeString);
  //     const year = date.getFullYear();
  //     const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  //     const day = String(date.getDate()).padStart(2, '0');
  //     const hours = String(date.getHours()).padStart(2, '0');
  //     const minutes = String(date.getMinutes()).padStart(2, '0');
  //     const seconds = String(date.getSeconds()).padStart(2, '0');
  //     return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  //   };
  //   // Fetch the SVG image and convert to base64
  //   const response = await fetch(centerImage);
  //   const blob = await response.blob();
  //   const reader = new FileReader();
  //   reader.readAsDataURL(blob);
  //   reader.onloadend = () => {
  //     const base64Svg = reader.result;

  //     // Write the content into the iframe
  //     const doc = iframe.contentWindow.document;
  //     const formattedInTime = formatDateTime(responseWV.data.checkInDateTime);
  //     const formattedValidTill = formatDateTime(responseWV.data.extendedValidTill);
  //     const templateStyle = responseTemplate.data == 1
  //       ? `
  //       <style>
  //         @page { margin: 0; }
  //         body {
  //           font-family: Arial, sans-serif;
  //           display: flex;
  //           align-items: center;
  //           justify-content: center;
  //           padding: 20px;
  //           margin: 0;
  //         }
  //         .container {
  //           width: 250px;
  //           border: 1px solid #000;
  //           padding: 10px;
  //           text-align: center;
  //         }
  //         .header img {
  //           width: 100px;
  //           height: auto;
  //           margin-bottom: 10px;
  //         }
  //         .imageN img {
  //           width: 100px;
  //           height: 100px;
  //           margin-bottom: 10px;
  //         }
  //         .visitor-details {
  //           text-align: left;
  //           font-size: 14px;
  //           margin-top: 10px;
  //         }
  //         .visitor-details p {
  //           margin: 4px 0;
  //           display: flex;
  //         }
  //         .label {
  //           font-weight: 400;
  //           width: 80px;
  //         }
  //         .value {
  //           flex-grow: 1;
  //         }
  //         .footer {
  //           display: flex;
  //           justify-content: space-between;
  //           align-items: center;
  //           margin-top: 10px;
  //           padding-top: 10px;
  //         }
  //         .footer div {
  //           text-align: center;
  //           font-weight: 600;
  //           font-size: 12px;
  //         }
  //         .qr-code img {
  //           width: 80px;
  //           height: 80px;
  //         }
  //         @media print {
  //           .no-print {
  //             display: none;
  //           }
  //         }
  //       </style>
  //       `
  //       : `
  //       <style>
  //         @page { margin: 0; }
  //         body {
  //           font-family: Segoe UI;
  //           margin: 10;
  //           padding: 10;
  //         }
  //         .container {
  //           width: 7cm;
  //           height: 10.5cm;
  //           border: 1px solid #000;
  //           padding: 5px;
  //           text-align: center;
  //           box-sizing: border-box;
  //         }
  //         .header img {
  //           width: 90px;
  //           height: auto;
  //           margin-bottom: 6px;
  //         }
  //         .imageN img {
  //           width: 100px;
  //           height: 60px;
  //           margin-bottom: 6px;
  //         }
  //         .visitor-details {
  //           text-align: left;
  //           font-size: 10px;
  //           margin-top: 6px;
  //         }
  //         .visitor-details p {
  //           margin: 2px 0;
  //           display: flex;
  //         }
  //         .label {
  //           font-weight: 400;
  //           width: 70px;
  //         }
  //         .value {
  //           flex-grow: 1;
  //         }
  //         .footer {
  //           display: flex;
  //           justify-content: space-between;
  //           align-items: center;
  //           margin-top: 8px;
  //           padding-top: 6px;
  //         }
  //         .footer div {
  //           text-align: center;
  //           font-weight: 600;
  //           font-size: 9px;
  //         }
  //         .qr-code img {
  //           width: 60px;
  //           height: 60px;
  //         }
  //         @media print {
  //           .no-print {
  //             display: none;
  //           }
  //         }
  //       </style>
  //       `;
  //     doc.open();
  //     doc.write(`
  //       <html>
  //             <head>
  //               <title>Print QR Code</title>
  //                              ${templateStyle}

  //             </head>
  //             <body>
  //               <div class="container">
  //                 <!-- Company Logo -->
  //                 <div class="header">
  //                   <img src="${centerImage}" alt="Infosys Logo" />
  //                 </div>

  //                 <!-- Visitor Photo -->
  //                 <div class="imageN">
  //                   <img src="${profileImage}" alt="Visitor Photo" />
  //                 </div>

  //                 <!-- Visitor Details -->
  //                 <div class="visitor-details">
  //                   <p><span class="label">PassId:</span> <span class="value">${checkinData.appointmentId}</span></p>
  //                   <p><span class="label">Name:</span> <span class="value">${responseWV.data.visitorName}</span></p>
  //                   <p><span class="label">Org:</span> <span class="value">${newChek.visitorCompany}</span></p>
  //                   <p><span class="label">Location:</span> <span class="value">${newChek.meetingvenue}</span></p>
  //                   <p><span class="label">Purpose:</span> <span class="value">${formData.purpose || ''}</span></p>
  //                   <p><span class="label">Buildings:</span> <span class="value">${responseWV.data.buildingName}</span></p>
  //                   <p><span class="label">Gates:</span> <span class="value">${responseWV.data.gateName}</span></p>
  //                   <p><span class="label">IN-Time:</span> <span class="value">${formattedInTime}</span></p>
  //                   <p><span class="label">ValidTill:</span> <span class="value">${formattedValidTill}</span></p>
  //                   <p><span class="label">Assets:</span><span class="value">${formData.visitorAssets || " "}</span></p>
  //                   <p><span class="label">Remarks:</span><span class="value">${formData.remarks || " "}</span></p>
  //                   <p><span class="label">Card No:</span><span class="value">${formData.CardNumber || " "}</span></p>

  //                 </div>

  //                 <!-- Footer with QR Code and Signatures -->
  //                 <div class="footer">
  //                   <div style="display:flex;flex-direction:column;text-align:left;">
  //                     <div style="margin-bottom:30px;text-align:left">Visitor Sign</div>
  //                     <div>Employee Sign</div>
  //                   </div>
  //                   <div class="qr-code">
  //                     <img src="${qrCodeDataUrlV}" alt="QR Code" />
  //                   </div>
  //                 </div>
  //               </div>
  //             </body>
  //           </html>
  //     `);
  //     doc.close();

  //     // Use onload event to ensure the content and styles are fully loaded before printing
  //     iframe.onload = () => {
  //       setTimeout(() => {
  //         iframe.contentWindow.print();
  //         document.body.removeChild(iframe); // Remove the iframe after printing
  //       }, 500);
  //       navigate('/layout/Dashboard/Dashboard');
  //       // Slight delay for style rendering
  //     };
  //   };
  // };
  const generateQRCodeDataUrl = (data) => {
    return new Promise((resolve, reject) => {
      QRCode.toDataURL(data, { width: 256, margin: 1 }, (err, url) => {
        if (err) {
          console.error("Error generating QR Code:", err);
          reject(err);
        } else {
          resolve(url); // Return the data URL
        }
      });
    });
  };
  const [selectedGate, setSelectedGate] = useState("");

  const handleGateChange = async (event) => {
    const gateID = parseInt(event.target.value, 10); // Convert to integer if gate.id is a number
    const selectedGateObject = gates.find((gate) => gate.id === gateID);

    setSelectedGate(selectedGateObject); // Store the entire gate object

    setFormData((prev) => ({
      ...prev,
      gate: selectedGateObject.id,
    }));

    // try {
    //   const buildings = await fetchBuildingsByGate(gateID);
    //   setBuildings(buildings);
    // } catch (error) {
    //   console.error("Error fetching buildings:", error);
    // }
  };

  //console.log("filedData", fieldData)
  //acknowladge feature
  const [entity, setEntity] = useState([]); // Properly initialized as an empty array
  const [ackChecklist, setAckChecklist] = useState({});
  //console.log("acknowleaged list", ackChecklist);

  const [detailsValid, setDetailsValid] = useState(false); // controls Acknowledge tab enable
  const [openVideoModal, setOpenVideoModal] = useState(false);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [passACKData, setPassACKData] = useState("");
  const empId = localStorage.getItem("employeeId");
  const [pdfUrl, setPdfUrl] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [openPdfModal, setOpenPdfModal] = useState(false);
  const [agreedRows, setAgreedRows] = useState({});
  const [ndaDocumentFileName, setNdaDocumentFileName] = useState("");
  const [ndaDocumnet, setNdaDocument] = useState("");

  useEffect(() => {
    const fetchAppointmentDataeempEntity = async () => {
      if (!data?.entityId) {
        toast.error("Entity ID is missing");
        return;
      }

      try {
        const responseEntity = await axios.get(
          `/Entity/GetEntityByID/${data?.entityId}`,
        );
        console.log("response", responseEntity?.data);
        const selectedEntity = responseEntity?.data;

        // If you want to keep it in state for modal usage:
        setEntity(responseEntity?.data);
        // Dynamically build the checklist based on what exists in the entity
        const initialChecklist = {};

        if (
          selectedEntity?.uploadTrainingVideos &&
          selectedEntity?.trainingVideosLink
        )
          initialChecklist.training = false;

        if (
          selectedEntity?.uploadSafetyGuidelinesDocuments &&
          selectedEntity?.safetyGuidelines?.safetyGuidelinesDocumentLink
        )
          initialChecklist.safetyDoc = false;

        if (
          selectedEntity?.uploadSafetyGuidelinesDocuments &&
          selectedEntity?.safetyGuidelines?.safetyGuidelinesVideoLink
        )
          initialChecklist.safetyVideo = false;

        if (selectedEntity?.ndaDocument) initialChecklist.ndaDoc = false;

        // Set it in state
        setAckChecklist(initialChecklist);
      } catch (error) {
        console.error("Error fetching appointment data:", error);
      }
    };
    fetchAppointmentDataeempEntity();
  }, [data]);

  return (
    <Container>
      <ToastContainer />
      <Header>
        <Heading>Visitor Check-In Form</Heading>
        <ButtonGroup>
          {(activeTab === "details" || activeTab === "additional") && (
            <ResetButton onClick={handleReset}>Reset</ResetButton>
          )}
          {activeTab === "acknowledge" && (
            <ResetButton onClick={handleResetAcknowledgement}>
              Reset
            </ResetButton>
          )}
          {activeTab === "details" && (
            <SubmitButton onClick={() => setActiveTab("additional")}>
              Next
            </SubmitButton>
          )}
          {activeTab === "additional" && (
            <SubmitButton onClick={handleNext}>Next</SubmitButton>
          )}
          {activeTab === "acknowledge" && (
            <SubmitButton onClick={handleSubmit}>Submit</SubmitButton>
          )}
        </ButtonGroup>
      </Header>
      <Tabs>
        <Tab
          active={activeTab === "details"}
          onClick={() => setActiveTab("details")}
        >
          Details
        </Tab>
        <Tab
          active={activeTab === "additional"}
          onClick={() => setActiveTab("additional")}
        >
          Additional
        </Tab>
        <Tab
          active={activeTab === "acknowledge"}
          disabled={!detailsValid} // disable until details are valid
          onClick={() => setActiveTab("acknowledge")}
        >
          Acknowledgement
        </Tab>
      </Tabs>
      <TabContent active={activeTab === "details"}>
        <CardContainer>
          <Card>
            <FormGroup>
              <Label>
                Visitor Type<Asterisk> *</Asterisk>
              </Label>
              <Select
                name="visitorType"
                value={formData.visitorType}
                onChange={handleInputChange}
                disabled={true} // Disable input based on condition
              >
                <option value="">Select type</option>
                {visitorTypes?.map((type) => (
                  <option
                    key={type.id}
                    value={type.id}
                    selected={
                      checkinData &&
                      checkinData &&
                      type.id === checkinData.selectedVisitorTypeId
                    }
                  >
                    {type.visitorTypeDesc}
                  </option>
                ))}
              </Select>
            </FormGroup>
            <FormGroup>
              <Label>
                Visitor Company<Asterisk> *</Asterisk>
              </Label>
              <Input
                type="text"
                name="visitorCompany"
                placeholder="Enter Company"
                value={formData.visitorCompany}
                onChange={handleInputChange}
                disabled={true} // Disable input based on condition
              />
            </FormGroup>
            {/* <FormGroup>
              <Label>
                Visitor Name<Asterisk> *</Asterisk>
              </Label>
              <Input
                type="text"
                name="visitorName"
                value={formData.visitorName}
                onChange={handleInputChange}
                placeholder="Enter visitor name"
                style={{
                  borderBottomColor: formErrors.visitorName ? 'red' : '#2b3497',
                }}
                disabled={true} // Disable input based on condition

              />
            </FormGroup> */}
            <FormRow>
              <FormGroup>
                <Label>
                  First Name
                  {fieldData?.visitorNameField && <Asterisk> *</Asterisk>}
                </Label>
                <Input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  placeholder="Enter First Name"
                  disabled={formData.firstName ? true : false}
                />
              </FormGroup>

              <FormGroup>
                <Label>Middle Name</Label>
                <Input
                  type="text"
                  name="middleName"
                  value={formData.middleName}
                  onChange={handleInputChange}
                  placeholder="Enter Middle Name (Optional)"
                  style={{ borderColor: "#2B3497" }}
                  disabled={true}
                />
              </FormGroup>

              <FormGroup>
                <Label>
                  Last Name
                  {fieldData?.visitorNameField && <Asterisk> *</Asterisk>}
                </Label>
                <Input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  placeholder="Enter Last Name"
                  disabled={formData.lastName ? true : false}
                />
              </FormGroup>
            </FormRow>
            <FormGroup>
              <Label>
                Visitor Email
                {fieldData?.visitorEmailField && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="email"
                name="emailId"
                value={formData.emailId}
                placeholder="Enter Email"
                onChange={handleInputChange}
                style={{
                  borderBottomColor: formErrors.emailId ? "red" : "#2b3497",
                }}
                disabled={true} // Disable input based on condition
              />
            </FormGroup>
            <FormGroup>
              <Label>
                Gender
                {fieldData?.genderField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="gender"
                value={formData.gender}
                onChange={handleInputChange}
                disabled={true}
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="other">Other</option>
              </Select>
              {formErrors.gender && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a gender
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Nationality
                {fieldData?.nationalityField && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="text"
                name="nationality"
                value={formData.nationality}
                onChange={handleInputChange}
                placeholder="Enter Last Name"
                disabled={true}
              />
            </FormGroup>
            <FormGroup>
              <Label>
                Visitor Mobile
                {fieldData?.visitorMobileField && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="tel"
                name="visitorMobile"
                value={formData.visitorMobile}
                placeholder="Enter  Mobile number"
                maxLength="10"
                onChange={handleInputChange}
                style={{
                  borderBottomColor: formErrors.visitorMobile
                    ? "red"
                    : "#2b3497",
                }}
                disabled={true} // Disable input based on condition
              />
            </FormGroup>
            <FormGroup>
              <Label>
                Location
                {fieldData?.locationField && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="text"
                name="building"
                placeholder="Enter location"
                value={formData.meetingVenue}
                onChange={handleInputChange}
                disabled={true}
              />
              {formErrors.meetingVenue && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {" "}
                  {formErrors.meetingVenue}
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Gate
                {fieldData?.gateField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="gate"
                value={selectedGate ? selectedGate.id : ""}
                onChange={handleGateChange}
              >
                <option value="">Select Gate</option>
                {gates.map((gate) => (
                  <option key={gate.id} value={gate.id}>
                    {gate.name}
                  </option>
                ))}
              </Select>
              {/* <Input
                type="text"
                name="gate"
                placeholder="Enter Gate"
                value={newChek?.gate}
                onChange={handleInputChange}
                disabled={newChek?.gate}
              /> */}
              {formErrors.gate && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {" "}
                  {formErrors.gate}
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Area
                {fieldData?.areaField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="building"
                value={formData.building}
                onChange={handleChange}
              >
                <option value="">Select Area</option>
                {Array.isArray(buildings) &&
                  buildings.map((building) => (
                    <option key={building.id} value={building.id}>
                      {building.name}
                    </option>
                  ))}
              </Select>
              {formErrors.building && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {" "}
                  {formErrors.building}
                </span>
              )}
            </FormGroup>

            <FormGroup>
              <Label>Assets{isCheckedB && <Asterisk> *</Asterisk>}</Label>
              <Input
                type="text"
                name="visitorAssets"
                value={formData.visitorAssets}
                placeholder="Enter Assets count"
                onChange={handleInputChange}
              />
              {formErrors.visitorAssets && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {" "}
                  {formErrors.visitorAssets}
                </span>
              )}
            </FormGroup>
          </Card>
          <Card>
            <FormGroup>
              <Label>Vehicle No</Label>
              <Input
                type="text"
                name="vehicleNo"
                placeholder="Enter Vehicle No"
                value={formData.vehicleNo}
                onChange={handleInputChange}
              />
            </FormGroup>
            <FormGroup>
              <Label>Remarks{isCheckedB && <Asterisk> *</Asterisk>}</Label>
              <Input
                type="text"
                name="remarks"
                placeholder="Enter Remarks"
                value={formData.remarks}
                onChange={handleInputChange}
              />
              {formErrors.remarks && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {" "}
                  {formErrors.remarks}
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Purpose {fieldData?.purpose && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="text"
                name="purpose"
                value={formData.purpose}
                placeholder="Enter purpose"
                onChange={handleInputChange}
                disabled={fieldData.purpose}
              />
              {formErrors.purpose && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {" "}
                  {formErrors.purpose}
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Meeting From<Asterisk> *</Asterisk>
              </Label>
              <StyledDatePicker
                selected={formData.meetingFrom}
                onChange={(date) =>
                  setFormData((prevData) => ({
                    ...prevData,
                    meetingFrom: date,
                  }))
                }
                showTimeSelect
                dateFormat="Pp"
                disabled={formData.meetingFrom ? true : false} // Disable input based on condition
              />
            </FormGroup>
            <FormGroup>
              <Label>
                Meeting To<Asterisk> *</Asterisk>
              </Label>
              <StyledDatePicker
                selected={formData.meetingTo}
                onChange={(date) =>
                  setFormData((prevData) => ({ ...prevData, meetingTo: date }))
                }
                showTimeSelect
                dateFormat="Pp"
                disabled={formData.meetingTo ? true : false} // Disable input based on condition
              />
            </FormGroup>
            <FormGroup>
              <Label>
                Id Proof Type
                {fieldData?.idProofTypeField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="idProofId"
                value={formData.idProofId}
                onChange={handleChange}
                disabled={fieldData?.idProofTypeField} // Disable input based on condition
              >
                <option value="">Select ID Proof Type</option>
                {idProofTypes.map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.idProofDescription}
                  </option>
                ))}
              </Select>
              {formErrors.idProofId && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a Id Prood type
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Id Proof Number
                {fieldData?.idProofNumberField && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="text"
                name="visitorIdNumber"
                maxLength={4}
                value={formData.visitorIdNumber}
                onChange={handleChange}
                placeholder="Enter Id Proof Number"
                style={{
                  borderColor: formErrors.visitorIdNumber ? "red" : "2B3497",
                }}
                disabled={fieldData?.idProofNumberField} // Disable input based on condition
              />
              {formErrors.visitorIdNumber && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please Fill the Id Proof Number
                </span>
              )}
              {/* <input
                type="text"
                name="visitorIdNumber"
                placeholder="Enter Id Proof Number"
                value={formData.visitorIdNumber}
                onChange={(e) => {
                  const value = e.target.value;
                  const regex = /^[a-zA-Z0-9]*$/;
                  if (value === '' || regex.test(value)) {
                    handleInputChange(e);
                  }
                }}
                style={{ border: '1px solid black', padding: '5px', width: '100%' }}
              />
              {formErrors.visitorIdNumber && (
                <span style={{ color: 'red', fontSize: '12px' }}>
                  Please Fill the Id Proof Number
                </span>
              )} */}
            </FormGroup>
            <FormGroup>
              <Label>Transport Vendor Document</Label>

              <FileUploadContainer>
                <CustomFileButton
                  onClick={() =>
                    document.getElementById("transportVendorFileInput").click()
                  }
                >
                  Choose File
                </CustomFileButton>

                <FileNameInput
                  type="text"
                  value={transportVendorFileName || ""}
                  placeholder="No file chosen"
                  readOnly
                />

                <HiddenFileInput
                  id="transportVendorFileInput"
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setTransportVendorFileName(file.name);

                      try {
                        const base64String = await fileToBase64(file);
                        setTransportVendorFileBase64(base64String); // <-- raw base64 only
                      } catch (err) {
                        console.error("File conversion error:", err);
                      }
                    }
                  }}
                />
              </FileUploadContainer>
            </FormGroup>

            <AdditionalInputContainerN>
              <CheckboxContainer>
                <CheckboxLabel>All Day</CheckboxLabel>
                <Checkbox
                  type="checkbox"
                  checked={isAllDayChecked}
                  disabled={true}
                  onChange={handleAllDayCheckboxChange}
                />
              </CheckboxContainer>
            </AdditionalInputContainerN>
            <CheckboxContainer>
              <CheckboxLabel>Repeat Visit</CheckboxLabel>
              <Checkbox
                type="checkbox"
                checked={isChecked}
                disabled={true}
                onChange={handleCheckboxChange}
              />
            </CheckboxContainer>

            <HeaderN>Scheduler</HeaderN>

            <DropdownContainer>
              <DropdownLabel>Recurrence Pattern:</DropdownLabel>
              <StyledDropdown
                value={recurrencePattern}
                disabled={true}
                onChange={handleDropdownChange}
              >
                <option value="" disabled>
                  Select pattern
                </option>
                <option value="1">Daily</option>
                <option value="2">Weekly</option>
                <option value="3">Monthly</option>
              </StyledDropdown>
            </DropdownContainer>

            {/* Daily input for selecting the day */}
            {/* <InputContainer show={recurrencePattern === '1'}>
              <SpinnerInputLabel>Recur Every:</SpinnerInputLabel>
              <SpinnerInput disabled={true} type="number" min="1" max="31" value={selectedDay} onChange={handleDayChange} />
            </InputContainer> */}

            {/* Weekly dropdown for selecting the weekday */}

            <InputContainer show={recurrencePattern === "2"}>
              <DropdownLabel>Select Weekdays:</DropdownLabel>
              <CheckboxContainernew>
                {[
                  "Sunday",
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                ]?.map((day, index) => (
                  <CheckboxLabelnew key={index}>
                    <Checkbox
                      type="checkbox"
                      disabled={true}
                      checked={selectedWeekday?.includes(index + 1)} // Check based on array values
                      onChange={() => handleWeekdayCheckboxChange(index + 1)}
                    />
                    {day}
                  </CheckboxLabelnew>
                ))}
              </CheckboxContainernew>
            </InputContainer>

            {/* Monthly dropdown for selecting the month */}
            <InputContainer show={recurrencePattern === "3"}>
              <DropdownLabel>Select Months:</DropdownLabel>
              <CheckboxContainernew>
                {[
                  "January",
                  "February",
                  "March",
                  "April",
                  "May",
                  "June",
                  "July",
                  "August",
                  "September",
                  "October",
                  "November",
                  "December",
                ]?.map((month, index) => (
                  <CheckboxLabelnew key={index}>
                    <Checkbox
                      type="checkbox"
                      disabled={true} // Enable for interaction
                      checked={selectedMonth?.includes(index + 1)} // Check if month is selected
                      onChange={() => handleMonthCheckboxChange(index + 1)} // Handle checkbox change
                    />
                    {month}
                  </CheckboxLabelnew>
                ))}
              </CheckboxContainernew>
            </InputContainer>

            {/* All Day checkbox and Recur Every input */}
            <InputContainer
              show={
                recurrencePattern === "2" ||
                recurrencePattern === "3" ||
                recurrencePattern === "1"
              }
            >
              <SpinnerInputLabel>Recur Every:</SpinnerInputLabel>
              <RecurrenceInput
                disabled={true}
                type="number"
                min="0"
                value={recurEvery}
                onChange={handleRecurEveryChange}
              />
            </InputContainer>

            {/* <AdditionalInputContainer show={recurrencePattern === '2' || recurrencePattern === '3'}>
              <CheckboxContainer>
                <Label>All Day</Label>
                <Checkbox type="checkbox" disabled={true} checked={isAllDayChecked} onChange={handleAllDayCheckboxChange} />
              </CheckboxContainer>
            </AdditionalInputContainer> */}
          </Card>
          <Card>
            <FormGroup>
              <Heading>Host Details</Heading>
            </FormGroup>
            <FormGroup>
              <Label>
                Employee Name<Asterisk> *</Asterisk>
              </Label>
              <Input
                type="text"
                name="employeeName"
                value={formData.employeeName}
                onChange={handleInputChange}
                placeholder="Enter employee name"
                disabled={formData.employeeName ? true : false} // Disable input based on condition
              />
            </FormGroup>
            <FormGroup>
              <Label>
                Employee Mobile<Asterisk> *</Asterisk>
              </Label>
              <Input
                type="text"
                name="employeeMobile"
                value={formData.employeeMobile}
                onChange={handleInputChange}
                placeholder="Enter employee mobile"
                disabled={formData.employeeMobile ? true : false} // Disable input based on condition
              />
            </FormGroup>
            <VisitorPhotoHeading>Visitor Photo</VisitorPhotoHeading>
            <ProfileText>(Only JPEG and PNG Images)</ProfileText>
            <Circle>
              <WebcamContainer>
                {isCameraOn && (
                  <Webcam
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/png"
                    width="100%"
                    height="100%"
                    videoConstraints={{
                      width: 200,
                      height: 200,
                      facingMode: "user",
                    }}
                  />
                )}
                {!isCameraOn && profileImage && (
                  <img
                    src={profileImage}
                    alt="Profile"
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                    }}
                  />
                )}
                {!isCameraOn && !profileImage && (
                  <ProfileIcon>
                    <User size={40} />
                  </ProfileIcon>
                )}
              </WebcamContainer>
            </Circle>
            <ButtonRow>
              <PhotoButton onClick={handleCapture}>{buttonLabel}</PhotoButton>
            </ButtonRow>
            <ButtonRow>
              <ActionButton onChange={handleImageUpload}>
                <label htmlFor="upload-button" style={{ cursor: "pointer" }}>
                  Upload images
                </label>
              </ActionButton>
            </ButtonRow>
            <input
              id="upload-button"
              type="file"
              accept="image/png, image/jpeg"
              style={{ display: "none" }}
              onChange={handleImageUpload}
            />
            <CheckboxRowContainer>
              <CheckboxContainer>
                <input
                  type="checkbox"
                  checked={isCheckedB}
                  onChange={handleCheckboxChangeB}
                />
                <span>
                  <PrivacyLink>Print-Baggage Tag</PrivacyLink>
                </span>
              </CheckboxContainer>
              <CheckboxContainer>
                <input
                  type="checkbox"
                  checked={isCheckedP}
                  onChange={handleCheckboxChangeP}
                />
                <span>
                  <PrivacyLink onClick={handlePrivacyLinkClickPrivacy}>
                    Privacy Policy<span style={{ color: "red" }}> *</span>
                  </PrivacyLink>
                </span>
              </CheckboxContainer>
              <CheckboxContainer>
                <input
                  type="checkbox"
                  checked={isCheckedC}
                  onChange={handleCheckboxChangeC}
                />
                <span>
                  <PrivacyLink onClick={handlePrivacyLinkClickCovid}>
                    COVID Fitness<span style={{ color: "red" }}> *</span>
                  </PrivacyLink>
                </span>
              </CheckboxContainer>
            </CheckboxRowContainer>
          </Card>
        </CardContainer>
      </TabContent>
      <TabContent active={activeTab === "additional"}>
        <CardContainer>
          <Card>
            <SwitchContainer>
              <SwitchRow>
                <SwitchLabel>Assistance Required</SwitchLabel>
                <Switch
                  isOn={isAssistanceRequired}
                  onClick={!disabled ? toggleAssistanceRequired : undefined}
                >
                  <SwitchSlider isOn={isAssistanceRequired} />
                  <SwitchText isOn={isAssistanceRequired}>
                    {isAssistanceRequired ? "Yes" : "No"}
                  </SwitchText>
                </Switch>
              </SwitchRow>

              <SwitchRow>
                <SwitchLabel>Service Provider Access</SwitchLabel>
                <Switch
                  isOn={isServiceProviderAccess}
                  onClick={!disabled ? toggleServiceProviderAccess : undefined}
                >
                  <SwitchSlider isOn={isServiceProviderAccess} />
                  <SwitchText isOn={isServiceProviderAccess}>
                    {isServiceProviderAccess ? "Yes" : "No"}
                  </SwitchText>
                </Switch>
              </SwitchRow>

              <SwitchRow>
                <SwitchLabel>WiFi Required</SwitchLabel>
                <Switch
                  isOn={isWiFiRequired}
                  onClick={!disabled ? toggleWiFiRequired : undefined}
                >
                  <SwitchSlider isOn={isWiFiRequired} />
                  <SwitchText isOn={isWiFiRequired}>
                    {isWiFiRequired ? "Yes" : "No"}
                  </SwitchText>
                </Switch>
              </SwitchRow>

              <SwitchRow>
                <SwitchLabel>Escort Required</SwitchLabel>
                <Switch
                  isOn={isEscortRequired}
                  onClick={!disabled ? toggleEscortRequired : undefined}
                >
                  <SwitchSlider isOn={isEscortRequired} />
                  <SwitchText isOn={isEscortRequired}>
                    {isEscortRequired ? "Yes" : "No"}
                  </SwitchText>
                </Switch>
              </SwitchRow>
              <SwitchRow>
                <SwitchLabel> Additional Notification</SwitchLabel>
                <Switch
                  isOn={isadditionalNotify}
                  onClick={
                    !disabled ? toggleadditionalNotifyRequired : undefined
                  }
                >
                  <SwitchSlider isOn={isadditionalNotify} />
                  <SwitchText isOn={isadditionalNotify}>
                    {isadditionalNotify ? "Yes" : "No"}
                  </SwitchText>
                </Switch>
              </SwitchRow>
            </SwitchContainer>
            <FormGroup style={{ marginTop: "20px" }}>
              <Label>Card Number</Label>
              <Input
                type="text"
                name="CardNumber"
                value={formData.CardNumber}
                placeholder="Enter card number"
                maxLength="9"
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only numeric input
                  if (/^\d*$/.test(value)) {
                    handleInputChange(e); // Update form data only if the input is valid
                  }
                }}
                style={{
                  borderBottomColor: formErrors.CardNumber ? "red" : "#2b3497",
                }}
              />
            </FormGroup>

            <InputFieldContainer>
              <InputLabelN>
                Notify to:
                {isadditionalNotify && <Asterisk> *</Asterisk>}
              </InputLabelN>
              <ChipContainer>
                {selectedEmails?.map((email, index) => (
                  <Chip key={index}>
                    {email}
                    {isadditionalNotify && (
                      <RemoveChipButton
                        disabled={true}
                        style={{ pointerEvents: "none" }}
                        onClick={() => handleChipRemove(email)}
                      >
                        &times;
                      </RemoveChipButton>
                    )}
                  </Chip>
                ))}
                <InputField
                  value={inputValue}
                  onChange={handleInputChangeE}
                  onKeyDown={handleKeyDown}
                  disabled={true}
                  placeholder="Enter email ID"
                />
              </ChipContainer>
              {filteredSuggestions.length > 0 && (
                <SuggestionBox>
                  {filteredSuggestions.map((emp) => (
                    <SuggestionItem key={emp.id}>
                      {emp.employeeMailId} - {emp.employeeName}
                    </SuggestionItem>
                  ))}
                </SuggestionBox>
              )}
            </InputFieldContainer>

            {/* Additional Input Fields */}
            <InputFieldContainer>
              <InputLabel>Message to Visitors:</InputLabel>
              <StyledTextArea
                value={additionalMessage}
                onChange={handleAdditionalMessageChange}
                placeholder="Enter message here"
                rows={recurrencePattern === "1" ? 3 : 6}
                disabled={true} // Adjust as needed for the number of lines shown by default
              />
            </InputFieldContainer>

            <InputFieldContainer>
              <InputLabel>Check-In Instructions:</InputLabel>
              <StyledTextArea
                value={checkInInstructions}
                onChange={handleCheckInInstructionsChange}
                placeholder="Enter instructions here"
                rows={recurrencePattern === "1" ? 3 : 6}
                disabled={true} // Adjust as needed for the number of lines shown by default
              />
            </InputFieldContainer>
          </Card>
        </CardContainer>
      </TabContent>

      <TabContent active={activeTab === "acknowledge"}>
        <CardContainer>
          <Card>
            {(entity?.uploadTrainingVideos && entity?.trainingVideosLink) ||
            (entity?.uploadSafetyGuidelinesDocuments &&
              (entity?.safetyGuidelines?.safetyGuidelinesDocumentLink ||
                entity?.safetyGuidelines?.safetyGuidelinesVideoLink)) ||
            entity?.ndaDocument ? (
              <>
                {/* Training Videos */}
                {entity?.uploadTrainingVideos && entity?.trainingVideosLink && (
                  <AckItem>
                    {/* Checkbox only controls state */}
                    <input
                      type="checkbox"
                      id="training"
                      checked={ackChecklist?.training || false}
                      onChange={(e) =>
                        setAckChecklist({
                          ...ackChecklist,
                          training: e.target.checked,
                        })
                      }
                    />

                    <AckText>
                      I acknowledge I have watched the{" "}
                      <span
                        style={{
                          color: "#293495",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.preventDefault(); // prevent checkbox toggle when clicking link
                          setVideoUrl(entity.trainingVideosLink);
                          setOpenVideoModal(true);
                        }}
                      >
                        Training Video
                      </span>
                    </AckText>
                  </AckItem>
                )}

                {/* Safety Guidelines Document */}
                {entity?.uploadSafetyGuidelinesDocuments &&
                  entity?.safetyGuidelines?.safetyGuidelinesDocumentLink && (
                    <AckItem htmlFor="safetyDoc">
                      <input
                        type="checkbox"
                        id="safetyDoc"
                        checked={ackChecklist?.safetyDoc || false}
                        onChange={(e) =>
                          setAckChecklist({
                            ...ackChecklist,
                            safetyDoc: e.target.checked,
                          })
                        }
                      />
                      <AckText>
                        I acknowledge I have read the{" "}
                        <span
                          style={{
                            color: "#293495",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            setShowPdfModal(true);
                          }}
                          href={
                            entity.safetyGuidelines.safetyGuidelinesDocumentLink
                          }
                          target="_self"
                          rel="noopener noreferrer"
                        >
                          Safety Guidelines Document
                        </span>
                      </AckText>
                    </AckItem>
                  )}

                {/* Safety Guidelines Video */}
                {entity?.uploadSafetyGuidelinesDocuments &&
                  entity?.safetyGuidelines?.safetyGuidelinesVideoLink && (
                    <AckItem>
                      {/* Checkbox only controls state */}
                      <input
                        type="checkbox"
                        id="safetyVideo"
                        checked={ackChecklist.safetyVideo || false}
                        onChange={(e) =>
                          setAckChecklist({
                            ...ackChecklist,
                            safetyVideo: e.target.checked,
                          })
                        }
                      />

                      <AckText>
                        I acknowledge I have watched the{" "}
                        <span
                          style={{
                            color: "#293495",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.preventDefault(); // don't let it trigger link behavior
                            setVideoUrl(
                              entity?.safetyGuidelines
                                ?.safetyGuidelinesVideoLink,
                            );
                            setOpenVideoModal(true);
                          }}
                        >
                          Safety Guidelines Video
                        </span>
                      </AckText>
                    </AckItem>
                  )}
                {entity?.ndaDocument && (
                  <AckItem>
                    <input
                      type="checkbox"
                      id="ndaDoc"
                      checked={ackChecklist.ndaDoc || false}
                      style={{ cursor: "not-allowed" }}
                      // disabled
                      // onChange={(e) =>
                      //   setAckChecklist({
                      //     ...ackChecklist,
                      //     ndaDoc: e.target.checked,
                      //   })
                      // }
                    />
                    <AckText>
                      I acknowledge I have read the{" "}
                      <span
                        style={{
                          color: "#293495",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={async (e) => {
                          e.preventDefault();
                          try {
                            const requestData = {
                              idProofNumber: formData?.visitorIdNumber,
                              hostID: parseInt(empId, 10),
                              visitorName:
                                formData?.firstName +
                                (formData?.middleName != null
                                  ? " " + formData.middleName
                                  : "") +
                                " " +
                                formData?.lastName,
                              visitorMobile: formData?.visitorMobile,
                              visitorCompany: formData?.visitorCompany,
                              nationalityCode: checkinData.nationalityCode,
                              ndadDocumentToken: "",
                              iAccpect: true,
                              checkInDateTime: new Date(),
                              VisitorType: String(
                                formData?.selectedVisitorTypeId,
                              ),
                            };

                            const response = await axios.post(
                              "/Entity/GetNDADocumentByVisitorDetails",
                              [requestData],
                            );

                            if (response.data && response.data.length > 0) {
                              const ndaPath = response.data[0].NDADocumentPath;

                              const fileResponse = await axios.get(
                                `/document/Documentdownload?token=${encodeURIComponent(
                                  ndaPath,
                                )}`,
                                { responseType: "blob" },
                              );

                              const pdfBlobUrl = window.URL.createObjectURL(
                                new Blob([fileResponse.data], {
                                  type: "application/pdf",
                                }),
                              );

                              setPdfUrl(pdfBlobUrl);
                              setSelectedRowId(entity.id);
                              setOpenPdfModal(true);
                            } else {
                              toast.error("No NDA document found.");
                            }
                          } catch (error) {
                            console.error(
                              "Error fetching NDA document:",
                              error,
                            );
                            toast.error("Failed to fetch the NDA document.");
                          }
                        }}
                      >
                        NDA Document
                      </span>
                    </AckText>
                  </AckItem>
                )}
                {ackChecklist.ndaDoc && (
                  <FormGroup>
                    <Label>NDA Document</Label>

                    <FileUploadContainer>
                      <CustomFileButton
                        onClick={() =>
                          document.getElementById("ndaDocument").click()
                        }
                      >
                        Choose File
                      </CustomFileButton>

                      <FileNameInput
                        type="text"
                        value={ndaDocumentFileName || ""}
                        placeholder="No file chosen"
                        readOnly
                      />

                      <HiddenFileInput
                        id="ndaDocument"
                        type="file"
                        accept=".pdf,.doc,.docx"
                        onChange={async (e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setNdaDocumentFileName(file.name);

                            try {
                              const base64String = await fileToBase64(file);
                              setNdaDocument(base64String); // store base64 string
                            } catch (err) {
                              console.error("File conversion error:", err);
                            }
                          }
                        }}
                      />
                    </FileUploadContainer>
                  </FormGroup>
                )}
              </>
            ) : (
              <div
                style={{
                  textAlign: "center",
                  padding: "2rem",
                  color: "#555",
                  fontSize: "1rem",
                }}
              >
                No acknowledgment materials are available at the moment.
              </div>
            )}
          </Card>
          {openPdfModal && (
            <PdfModalOverlay>
              <PdfModalContent>
                <CloseButtonIcon onClick={() => setOpenPdfModal(false)}>
                  ✖
                </CloseButtonIcon>
                <PdfFrame src={pdfUrl} title="NDA Document" />
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "15px" }}>
                  <AgreeButton onClick={() => setShowSignatureModal(true)}>
                    I Agree
                  </AgreeButton>
                </div>
              </PdfModalContent>
            </PdfModalOverlay>
          )}

          {showSignatureModal && (
            <PdfModalOverlay>
              <PdfModalContent style={{ maxWidth: "500px" }}>
                <CloseButtonIcon onClick={() => {
                  setShowSignatureModal(false);
                  if (sigCanvasRef.current) sigCanvasRef.current.clear();
                }}>
                  ✖
                </CloseButtonIcon>

                <h3 style={{ marginBottom: "10px", color: "#293495" }}>
                  Your Signature
                </h3>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "12px" }}>
                  Signature is mandatory. Please sign below to acknowledge the NDA Document.
                </p>

                {/* Signature Canvas */}
                <div style={{
                  border: "1px solid #2b3497",
                  borderRadius: "8px",
                  overflow: "hidden",
                  marginBottom: "12px",
                  background: "#f9f9f9"
                }}>
                  <SignatureCanvas
                    ref={sigCanvasRef}
                    penColor="black"
                    canvasProps={{
                      width: 450,
                      height: 200,
                      style: { display: "block" }
                    }}
                  />
                </div>

                {/* Clear + Confirm buttons */}
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <button
                    onClick={() => sigCanvasRef.current?.clear()}
                    style={{
                      padding: "8px 16px",
                      border: "2px solid #293495",
                      borderRadius: "6px",
                      background: "transparent",
                      color: "#293495",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                  >
                    Clear
                  </button>

                  <button
                    style={{
                      padding: "8px 16px",
                      background: "#293495",
                      color: "#fff",
                      border: "none",
                      borderRadius: "6px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = "#1f276f"}
                    onMouseLeave={(e) => e.currentTarget.style.background = "#293495"}
                    onClick={async () => {
                      // ✅ Signature is MANDATORY — block if empty
                      if (!sigCanvasRef.current || sigCanvasRef.current.isEmpty()) {
                        toast.error("Signature is mandatory. Please sign before proceeding.");
                        return;
                      }

                      // Capture base64 signature
                      const signatureDataURL = sigCanvasRef.current
                        .getCanvas()
                        .toDataURL("image/png");

                      console.log("Signature captured:", {
                        visitorName: `${formData.firstName} ${formData.lastName}`,
                        visitorMobile: formData.visitorMobile,
                        signedAt: new Date().toISOString(),
                        signatureBase64: signatureDataURL,
                      });

                      // Close signature modal
                      setShowSignatureModal(false);
                      sigCanvasRef.current.clear();

                      // Call API with VisitorSignature
                      try {
                        const requestData = {
                          idProofNumber: formData?.visitorIdNumber,
                          hostID: parseInt(empId, 10),
                          visitorName:
                            formData?.firstName +
                            (formData?.middleName != null ? " " + formData.middleName : "") +
                            " " +
                            formData?.lastName,
                          visitorMobile: formData?.visitorMobile,
                          visitorCompany: formData?.visitorCompany,
                          nationalityCode: checkinData.nationalityCode,
                          ndadDocumentToken: "",
                          iAccpect: true,
                          checkInDateTime: new Date(),
                          VisitorType: String(formData?.selectedVisitorTypeId),
                          NDASignature: signatureDataURL, // ✅ base64 signature
                        };

                        const response = await axios.post(
                          "/Entity/GetNDADocumentByVisitorDetails",
                          [requestData]
                        );

                        if (response.data && response.data.length > 0) {
                          const ndaPath = response.data[0].NDADocumentPath;

                          const fileResponse = await axios.get(
                            `/document/Documentdownload?token=${encodeURIComponent(ndaPath)}`,
                            { responseType: "blob" }
                          );

                          const updatedPdfBlobUrl = window.URL.createObjectURL(
                            new Blob([fileResponse.data], { type: "application/pdf" })
                          );

                          // Update PDF, mark agreed, close PDF modal
                          setPdfUrl(updatedPdfBlobUrl);
                          setAckChecklist((prev) => ({ ...prev, ndaDoc: true }));
                          setAgreedRows((prev) => ({ ...prev, [selectedRowId]: true }));
                          setOpenPdfModal(false);
                          toast.success("You agreed to the NDA.");
                        } else {
                          toast.error("No NDA document found.");
                        }
                      } catch (error) {
                        console.error("Error applying signature:", error);
                        toast.error("Failed to apply signature.");
                      }
                    }}
                  >
                    Confirm
                  </button>
                </div>
              </PdfModalContent>
            </PdfModalOverlay>
          )}

          {openVideoModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                background: "rgba(0,0,0,0.7)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 2000, // ensure above everything
              }}
            >
              <div
                style={{
                  position: "relative",
                  width: "80%",
                  maxWidth: "900px",
                  background: "#000",
                  borderRadius: "10px",
                  overflow: "hidden",
                }}
              >
                {/* Close button */}
                <button
                  onClick={() => {
                    setOpenVideoModal(false);
                    setVideoUrl(""); // clear video when closing
                  }}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    fontSize: "22px",
                    background: "transparent",
                    border: "none",
                    color: "#fff",
                    cursor: "pointer",
                    zIndex: 2100,
                  }}
                >
                  ✖
                </button>

                {/* Video Player */}
                {videoUrl.includes("youtube.com") ||
                videoUrl.includes("youtu.be") ? (
                  <iframe
                    width="100%"
                    height="500"
                    src={
                      videoUrl.includes("watch?v=")
                        ? videoUrl.replace("watch?v=", "embed/")
                        : videoUrl.replace("youtu.be/", "youtube.com/embed/")
                    }
                    title="Training Video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                ) : (
                  <video width="100%" height="500" controls autoPlay>
                    <source src={videoUrl} type="video/mp4" />
                    Your browser does not support HTML5 video.
                  </video>
                )}
              </div>
            </div>
          )}
        </CardContainer>
        {showPdfModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.7)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2000, // ensure above everything
              cursor: "pointer",
            }}
            onClick={() => setShowPdfModal(false)}
          >
            <div
              style={{
                position: "relative",
                width: "80%",
                maxWidth: "1120px",
                height: "80%",
                background: "#000",
                borderRadius: "10px",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  right: 0,
                  top: 0,
                }}
              >
                S
                <CloseButton onClick={() => setShowPdfModal(false)}>
                  ✖
                </CloseButton>
              </div>
              <iframe
                src={entity?.safetyGuidelines?.safetyGuidelinesDocumentLink}
                width="100%"
                height="100%"
                title="Safety Guidelines"
              />
            </div>
          </div>
        )}
        {/* <TableContainer>
                <StyledTable>
                  <thead>
                    <tr>
                      <TableHeader>Visitor Name</TableHeader>
                      <TableHeader>Nationality</TableHeader>
                      <TableHeader>Mobile</TableHeader>
                      <TableHeader>Company</TableHeader>
                      <TableHeader>ID Proof No</TableHeader>
                      <TableHeader>NDA Document</TableHeader>
                      <TableHeader>Action</TableHeader>
                    </tr>
                  </thead>
                  <tbody>
                    <TableRow>
                      <TableCell>
                        {passACKData.firstName}  {formData.passACKData}
                      </TableCell>
                      <TableCell>{passACKData.nationality}</TableCell>
                      <TableCell>{passACKData.visitorMobile}</TableCell>
                      <TableCell>{passACKData.company}</TableCell>
                      <TableCell>{passACKData.idProofNo}</TableCell>
      
                      <TableCell>
                        {entity?.ndaDocument ? (
                          <span
                            style={{ color: "#293495", cursor: "pointer", fontWeight: 500 }}
                            onClick={async () => {
                              try {
                                const requestData = {
                                  idProofNumber: passACKData.idProofNo,
                                  hostID: parseInt(empId, 10),
                                  visitorName: passACKData.firstName,
                                  visitorMobile: passACKData.visitorMobile,
                                  visitorCompany: passACKData.company,
                                  nationalityCode: passACKData.nationality,
                                  ndadDocumentToken: entity.ndaDocument,
                                  iAccpect: true,
                                };
      
                                const response = await axios.post(
                                  "/Entity/GetNDADocumentByVisitorDetails",
                                  [requestData]
                                );
      
                                if (response.data && response.data.length > 0) {
                                  const ndaPath = response.data[0].NDADocumentPath;
      
                                  const fileResponse = await axios.get(
                                    `/document/Documentdownload?token=${encodeURIComponent(ndaPath)}`,
                                    { responseType: "blob" }
                                  );
      
                                  const pdfBlobUrl = window.URL.createObjectURL(
                                    new Blob([fileResponse.data], { type: "application/pdf" })
                                  );
      
                                  setPdfUrl(pdfBlobUrl);
                                  setSelectedRowId(entity.id);
                                  setOpenPdfModal(true);
                                } else {
                                  toast.error("No NDA document found for this visitor.");
                                }
                              } catch (error) {
                                console.error("Error fetching NDA document:", error);
                                toast.error("Failed to fetch the NDA document. Please try again.");
                              }
                            }}
                          >
                            <i className="fas fa-eye" style={{ marginRight: "6px" }}></i>
                            View NDA
                          </span>
                        ) : (
                          "-"
                        )}
                      </TableCell>
      
                      <TableCell>
                        <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
                          <input
                            type="checkbox"
                            checked={!!agreedRows[entity.id]}
                            onChange={(e) => {
                              setAgreedRows(prev => ({
                                ...prev,
                                [entity.id]: e.target.checked,
                              }));
                            }}
                          />
                          I Agree
                        </label>
                      </TableCell>
      
                    </TableRow>
      
                  </tbody>
                </StyledTable>
              </TableContainer> */}
      </TabContent>
      {showQRCode && (
        <PopupContainer onClick={closeQRCodePopup}>
          <PopupContentN
            className="popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ textAlign: "center", marginBottom: "10px" }}>
              <img
                src={centerImage}
                alt="Infosys Logo"
                style={{ width: "170px", height: "100px" }}
              />
            </div>
            <h2
              style={{
                fontSize: "1.5em",
                margin: "10px 0",
                textAlign: "center",
              }}
            >
              {" "}
              {[formData.firstName, formData.middleName, formData.lastName]
                .filter(Boolean)
                .join(" ")}
            </h2>

            <div
              style={{
                backgroundColor: "#FF7A00",
                textAlign: "center",
                padding: "5px",
                color: "#FFF",
                fontWeight: "bold",
                fontSize: "1.2em",
                margin: "10px 0",
              }}
            >
              VISITOR
            </div>

            {/* QR Code with Visitor Data */}
            <div style={{ textAlign: "center" }}>
              <QRCodeCanvas ref={qrCodeRefV} value={qrCodeValueV} size={256} />
            </div>

            <div
              style={{
                backgroundColor: "#FF7A00",
                textAlign: "center",
                padding: "5px",
                color: "#FFF",
                fontWeight: "bold",
                fontSize: "1em",
                margin: "10px 0",
              }}
            >
              BAGGAGE TAG
            </div>

            <p
              style={{ fontSize: "0.8em", color: "#888", textAlign: "center" }}
            >
              Visitor Management System
            </p>
            <ButtonContainer
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <PopupButton onClick={printer}>Print</PopupButton>
              <PopupButton className="no-button" onClick={closeQRCodePopup}>
                Close
              </PopupButton>
            </ButtonContainer>
          </PopupContentN>
        </PopupContainer>
      )}
      {isPopupVisiblePrivacy && (
        <PopupOverlay>
          <PopupContent>
            <h3>Privacy Policy</h3>
            {entity?.privacyPolicy ? (
              <div> {entity?.privacyPolicy}</div>
            ) : (
              <div>
                <p>
                  While visiting facilities ("Facilities"), the visitor may have
                  access to or receive some information that is secret or
                  proprietary to Fidrox (collectively ‘Company’) concerning
                  their business or technology. The visitor undertakes to adhere
                  by the rules of this Agreement respecting the confidentiality
                  of any Confidential Information to which he or she has access
                  or receives.
                </p>
                <p>
                  “Confidential Information”: for purpose of this Agreement
                  shall mean and include, any and all information in written,
                  electronic, verbal or other form relating directly or
                  indirectly to the present or potential business, operation or
                  financial condition of or relating including, but not limited
                  to, information pertaining to pricing, marketing plans or
                  strategy, volumes, services rendered, customers and suppliers
                  lists, financial or technical or service matters or data,
                  trade secrets, designs, programming codes, personal or
                  sensitive data of any related parties, intellectual property,
                  and any information which might reasonably be presumed to be
                  proprietary or confidential in nature and also includes all
                  information identified by Company as confidential.
                </p>
                <p>I agree that:</p>
                <ul>
                  <li>
                    I have access to confidential information, I shall not
                    release, publish, or disclose such information to
                    unauthorized personnel. I shall protect such information and
                    will employ all reasonable efforts to maintain the
                    confidentiality of such information.
                  </li>
                  <li>
                    I shall immediately notify the Company-security personnel of
                    any suspected or confirmed unauthorized disclosure and/or
                    misuse of confidential information.
                  </li>
                  <li>
                    I shall not make any sound recordings, take any photographs
                    or make any movies, copies or reproductive images (in any
                    medium) of anything at the facility (ies); Upon Company’s
                    request, I shall promptly return all Confidential
                    Information received from Company together with all copies,
                    or certify in writing that all such Confidential Information
                    and copies thereof have been destroyed.
                  </li>
                  <li>
                    While entering Company data center, I consent for my
                    personal body and my belongings (baggage, luggage,
                    electronic gadgets, etc.) for security frisking purposes.
                  </li>
                  <li>
                    Company may collect certain personal information with
                    relation to the purpose of this agreement that is visiting
                    data center(s). I acknowledge it in detail at{" "}
                    <a
                      href="https://www.fidrox.com/privacy-policy/"
                      target="_blank"
                    >
                      https://www.fidrox.com/privacy-policy/
                    </a>
                    .
                  </li>
                  <li>
                    This Agreement shall remain in effect until such time as all
                    Confidential Information of Company disclosed hereunder
                    becomes publicly known without my action or inaction.
                  </li>
                </ul>
              </div>
            )}
            <ButtonContainer>
              <CloseButton onClick={handleClosePopupPrivacy}>Close</CloseButton>
            </ButtonContainer>
          </PopupContent>
        </PopupOverlay>
      )}
      {isPopupVisibleCovid && (
        <PopupOverlay>
          <PopupContent>
            <h3>Covid Fitness</h3>
            {entity?.covidFitness ? (
              <p>{entity?.covidFitness} </p>
            ) : (
              <p>
                The basic preventive measures include simple public health
                measures that are to be followed to reduce the risk of infection
                with COVID-19. These measures need to be observed by all
                (employees and visitors) at all times. These include: Physical
                distancing of at least one meter to be followed at all times.
                Use of face covers/masks to be mandatory. Practice frequent hand
                washing (for at least 40-60 seconds) even when hands are not
                visibly dirty and use of alcohol based hand sanitizers (for at
                least 20 seconds). Respiratory etiquettes to be strictly
                followed. This involves strict practice of covering one’s mouth
                and nose while coughing/sneezing with a
                tissue/handkerchief/flexed elbow and disposing off used tissues
                properly. Self-monitoring of health by all and reporting any
                illness at the earliest.Place the ill person in a room or area
                where they are isolated from others at the workplace. Provide a
                mask/face cover till such time he/she is examined by a doctor.
                Report to concerned central/state health authorities. Helpline
                1075 will be immediately informed. A risk assessment will be
                undertaken by the designated public health authority (district
                RRT/treating physician) and accordingly further advice shall be
                made regarding management of case, his/her contacts and need for
                disinfection. The suspect case if reporting very mild / mild
                symptoms on assessment by the health authorities would be placed
                under home isolation, subject to fulfilment of criteria laid
                down in MoHFW guidelines. Suspect case, if assessed by health
                authorities as moderate to severe, he/she will follow guidelines
                as laid down by MoHFW. The rapid response team of the concerned
                district shall be requisitioned and will undertake the listing
                of contacts. The necessary actions for contact tracing and
                disinfection of work place will start once the report of the
                patient is received as positive. The report will be expedited
                for this purpose.
              </p>
            )}
            <ButtonContainer>
              <CloseButton onClick={handleClosePopupCovid}>Close</CloseButton>
            </ButtonContainer>
          </PopupContent>
        </PopupOverlay>
      )}
      {showQRCodeV && (
        <PopupContainer onClick={closeQRCodePopupV}>
          <PopupContentN
            className="popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ textAlign: "center", marginBottom: "10px" }}>
              <img
                src={centerImage}
                alt="Infosys Logo"
                style={{ width: "170px", height: "100px" }}
              />
            </div>
            <h2 style={{ fontSize: "1.5em", margin: "10px 0" }}>
              {formData.groupLeaderName}
            </h2>

            <div
              style={{
                backgroundColor: "#FF7A00",
                padding: "5px",
                color: "#FFF",
                fontWeight: "bold",
                fontSize: "1.2em",
                margin: "10px 0",
              }}
            >
              VISITOR
            </div>

            {/* QR Code with Visitor Data */}
            <QRCodeCanvas ref={qrCodeRefV} value={qrCodeValueV} size={256} />

            {/* <div style={{ backgroundColor: '#FF7A00', padding: '5px', color: '#FFF', fontWeight: 'bold', fontSize: '1em', margin: '10px 0' }}>
              BAGGAGE TAG
            </div> */}

            <p style={{ fontSize: "0.8em", color: "#888" }}>
              Visitor Management System
            </p>

            <p>Visitor Management System</p>

            <ButtonContainer
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <PopupButton onClick={printQRCodeV}>Print</PopupButton>
              <PopupButton className="no-button" onClick={closeQRCodePopupV}>
                Close
              </PopupButton>
            </ButtonContainer>
          </PopupContentN>
        </PopupContainer>
      )}
      {!isCheckedB && (
        <QRCodeCanvas
          ref={qrCodeRefV}
          value={qrCodeValueV}
          size={256}
          style={{ display: "none" }}
        />
      )}

      {showBaggageTag && (
        <PopupOverlay>
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "1.5rem",
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: baggageTag }} />
          </div>
        </PopupOverlay>
      )}
    </Container>
  );
};

export default CheckinVisitorFormC;
